<template>
  <div class="mainChild page-content" id="mainChild">
    <div>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>数据中心</el-breadcrumb-item>
        <el-breadcrumb-item>品牌商品库</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-show="divShow">
      <div class="carlss" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="divLoading">
        加载中
      </div>
    </div>
    <section style="padding: 20px;margin-bottom: 10px;background-color: white;">
      <div class="title f16" style="font-size: 20px;font-weight: 600;margin: 16px 0 16px 0;">
        <span v-for="(item, i) in newPlateList" :key="i" :class="activeKey == item.dictCode ? 'active' : ''"
          @click="navChange(item)">{{ item.dictName }}</span>
      </div>
      <section class="seaerch-wrapper" style="padding: 0px;margin: 0px;">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="产品信息" :label-width="formLabelWidth">
            <el-cascader filterable clearable size="small" v-model="list.productid" :options="options2"
              :props="productidChildren" collapse-tags @change="handleChange" @visible-change="getListBybmcid2"
              style="width: 100%;" :disabled="cascaderDisabled"></el-cascader>
          </el-form-item>
          <el-form-item label="商品标题" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入" v-model="list.itemtitle" size="small"></el-input>
          </el-form-item>
          <el-form-item label="平台" :label-width="formLabelWidth" v-if="platformShow == true">
            <el-select v-model="list.platform" filterable placeholder="请选择" size="small">
              <el-option label="淘宝天猫" value="TBTM"></el-option>
              <el-option label="淘宝" value="TB"></el-option>
              <el-option label="天猫" value="TM"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入" v-model="list.shopname" size="small"></el-input>
          </el-form-item>

          <el-form-item label="备注" :label-width="formLabelWidth" v-if="logintype == 'KEFU'">
            <el-input :clearable="true" placeholder="请输入" v-model="list.remark" size="small"></el-input>
          </el-form-item>
          <el-form-item label="状态" :label-width="formLabelWidth">
            <el-select v-model="list.status" filterable placeholder="请选择" size="small" multiple>
              <el-option label="指纹变化" value="1"></el-option>
              <el-option label="上架" value="2"></el-option>
              <el-option label="下架" value="3"></el-option>
              <el-option label="授权店铺" value="4"></el-option>
              <el-option label="灰名单" value="5"></el-option>
              <el-option label="黑名单" value="6"></el-option>
              <el-option label="链接失效" value="7"></el-option>
              <el-option label="自动打标" value="8"></el-option>
              <el-option label="非自动打标" value="9"></el-option>
              <el-option label="全部未打标" value="12"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品ID" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入" v-model="list.itemid" size="small"></el-input>
          </el-form-item>
          <el-form-item label="更新时间" :label-width="formLabelWidth">
            <el-date-picker v-model="searchformDate" type="daterange" start-placeholder="请选择" end-placeholder="请选择"
              range-separator="~" :picker-options="pickerOptions" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="备注状态：" :label-width="formLabelWidth" v-if="logintype == 'KEFU'">
            <el-select v-model="list.complaintStatus" filterable clearable placeholder="请选择" size="small">
              <el-option label="123" value="1"></el-option>
              <el-option label="RJB" value="2"></el-option>
              <el-option label="MT" value="3"></el-option>
              <el-option label="TZ" value="4"></el-option>
              <el-option label="LZ" value="5"></el-option>
              <el-option label="PL" value="6"></el-option>
              <el-option label="投诉成功" value="7"></el-option>
              <el-option label="投诉失败" value="8"></el-option>
              <el-option label="审核中" value="9"></el-option>
              <el-option label="商家处理中" value="10"></el-option>
              <el-option label="已撤诉" value="11"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item v-if="logintype == 'KEFU' && dictCodeShow == 'TBTM' || logintype == 'KEFU' && dictCodeShow == 'PDD'" label="排序" :label-width="formLabelWidth">
            <el-select v-model="list.type" placeholder="请选择" size="small">
              <el-option label="数据更新时间降序" value=""></el-option>
              <el-option label="销量降序" value="1"></el-option>
              <el-option label="销售升序" value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item v-if="logintype != 'KEFU'"></el-form-item> -->
          <el-form-item
            v-if="dictCodeShow == 'TB' && logintype == 'HCM' || dictCodeShow == 'TBTM' && logintype == 'HCM'"></el-form-item>
          <el-form-item
            v-if="dictCodeShow == 'TB' && logintype == 'HCM' || dictCodeShow == 'TBTM' && logintype == 'HCM'"></el-form-item>

          <el-form-item
            v-if="dictCodeShow != 'TB' && dictCodeShow != 'TBTM' && dictCodeShow != 'PDD' && logintype == 'KEFU'"></el-form-item>
          <!-- <el-form-item v-if="dictCodeShow != 'TB' && dictCodeShow != 'TBTM' && dictCodeShow != 'PDD' && logintype == 'KEFU'"></el-form-item> -->
          <el-form-item>
            <el-button size="small" class="search-btn" @click="getIprPluginListList(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </section>
    <section class="content-warpper">
      <div class="headerBrand">
        <div class="searchContainer">
          <div class="searchContainerMainInfo">
            <div class="searchContainerMain" :style="{ width: logintype == 'HCM' ? '510px' : '613px' }">
            </div>
          </div>
          <div style="margin-bottom: 8px;"
            v-if="logintype == 'KEFU' && dictCodeShow == 'YYC' || logintype == 'KEFU' && dictCodeShow == 'TBTM'">
            <el-tag type="warning" style="width: 100%;">
              <div style="float: left;width: 100%;white-space:nowrap;">
                <img src="../../../assets/img/other/trumpet_icon.png" style="margin: 9px 5px 0px 13px;float: left;">
                <div style="float: left;">
                  商品库更新需要设置账号Cookie信息，Cookie有效期七天，超时不能更新商品库。
                </div>
                <div style="float: right;color: #1890ff;cursor: pointer;" @click="cookieChange">
                  设置Cookie
                </div>
                <div style="float: right;color: #f5222d;padding-right: 24px;" v-if="this.cookidFont != ''">
                  <div style="padding-left: 5px;">
                    <div class="circle" style="float: left;">
                    </div>
                    {{ this.cookidFont }}
                  </div>
                </div>

              </div>
            </el-tag>
          </div>
          <div class="downBtn"
            v-if="logintype != 'DEALER' && logintype != 'HCMSUB' && logintype != 'HCM' && logintype != 'SHOP'">
            <el-button @click="downTable" size="small" :loading="downTableTrue" type="primary"
              :disabled="disbutton">下载数据</el-button>
            <el-button @click="delBatches" size="small" :disabled="disbutton">批量删除</el-button>
            <el-button @click="forMoreLinks" size="small" :disabled="disbutton">快速入库详情</el-button>
            <el-button @click="syncDailyLowPrice" size="small" :loading="LowPriceLoading"
              :disabled="disbutton">同步每日违规</el-button>
            <el-button @click="updateSettings" size="small" :loading="updateSetLoading"
              :disabled="disbutton || disbutton2 || showChange">{{ btnName }}</el-button>
            <el-button @click="updateProcess" size="small" :disabled="disbutton || showChange">更新进程</el-button>
            <!-- <el-button @click="updateSettings" size="small" :loading="updateSetLoading" :disabled="disbutton || dictCodeShow == 'PDD' || disbutton2">{{btnName}}</el-button>
            <el-button @click="updateProcess" size="small" :disabled="disbutton || dictCodeShow == 'PDD'">更新进程</el-button> -->
            <el-button @click="marking" size="small" :disabled="disbutton">批量打标</el-button>
            <el-button @click="remakIng" size="small" :disabled="disbutton">批量备注</el-button>
            <el-button @click="Synchronize" size="small" :disabled="disbutton">同步禁售链接</el-button>
            <el-button @click="screenshotShow = true" size="small" :disabled="disbutton">截图设置</el-button>
            <el-button @click="jumpPdd" v-if="dictCodeShow == 'DY'" size="small" :disabled="disbutton">关键词入库</el-button>
            <div style="margin-left: 10px;line-height: 29px;font-size: 14px;color: #999;">
              上次自动更新完成时间：
              <span v-if="updatetime">{{ updatetime | fullTime }}</span>
              <span v-else>--</span>
            </div>
          </div>
          <div class="downBtn" v-else>
            <el-button @click="downTable" type="primary" size="small" :loading="downTableTrue">下载数据</el-button>
          </div>
        </div>
      </div>
      <tableHeader :selectAll='selectAll' :headerShow="true" :brandStore="true" :batchDisable="batchDisable"
        :chekTableNum="chekTableNum" @allCheck="toggleSelection(tableList, 'true')" @cancelAllCheck="toggleSelection()">
      </tableHeader>
      <div class="downContainer">
        <!--表格-->
        <el-table ref="multipleTable" :data="tableList" tooltip-effect="dark" style="width: 100%"
          @selection-change="selectionChange" v-loading="dataLoading" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading">
          <el-table-column type="selection" width="30" fixed="left">
          </el-table-column>
          <el-table-column label="序号" align="left" type="index" width="65" fixed="left">
            <template slot-scope="scope">
              {{ scope.$index | indexMethod(list.pageNo, list.pageSize) }}
              <img src="../../../assets/img/AI.png" alt=""
                style="width: 20px;height: 20px;float: right;cursor: pointer;" v-if="scope.row.autotype == 1"
                @click="aiChange(scope.row)">
            </template>
          </el-table-column>
          <el-table-column label="商品信息" prop="itemtitle" width="480">
            <template slot-scope="scope" class="shopInfo">
              <div class="shopMain">
                <!-- <img :src="scope.row.logopicurl_details?scope.row.logopicurl_details:scope.row.logopicurl" alt/> -->
                <el-image :src="scope.row.logopicurl_details ? scope.row.logopicurl_details : scope.row.logopicurl"
                  style="height: 84px;width: 84px;margin-right: 12px;"></el-image>
                <div class="content">
                  <el-link class="align_left two_ellipsis" :underline="false" :href="scope.row.itemlink" type="primary"
                    target="_blank">
                    {{ scope.row.itemtitle_details ? scope.row.itemtitle_details : scope.row.itemtitle }}
                  </el-link>
                  <i class="el-icon-edit-outline" style="color: #409eff;" @click="markingClick(scope.row)"
                    v-show="scope.row.itemtype != 2"></i>
                  <div class="align_left" v-show="scope.row.itemtype != 2">
                    {{ scope.row.productname }}
                    <el-popover placement="top-start" width="200" trigger="hover" v-show="scope.row.productname">
                      <div>
                        <div v-for="item in $options.filters.objToAr(scope.row.productPrice)" :key="item.name">
                          <div>{{ item.name }}:{{ item.val }}</div>
                        </div>
                      </div>
                      <i class="el-icon-warning-outline" slot="reference"></i>
                    </el-popover>
                  </div>
                  <el-button type="primary" size="mini" plain
                    @click="skuListChildShow(scope.row.itemid, scope.row.platform)" v-show="scope.row.itemtype == 2">
                    SKU列表
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="name" :label="dictCodeShow == '1688'
            ? (logintype !== 'KEFU' && bmcKefuid == '4581' ? '最高指数' : '最高价格')
            : (logintype !== 'KEFU' && bmcKefuid == '4581' ? '指数' : '价格')" width="200">
            <template slot-scope="scope">
              <div style="float: left;width: 100%;">
                <div v-if="scope.row.price" style="float: left;">
                  <span>
                    标价：
                  </span>
                  <span v-if="dictCodeShow == 'LZDVN'">
                    ₫
                  </span>
                  <span v-if="dictCodeShow == 'LZDSG'">
                    $
                  </span>
                  <span v-if="dictCodeShow == 'LZDID'">
                    Rp
                  </span>
                  <span v-if="dictCodeShow == 'LZDPH'">
                    ₱
                  </span>
                  <span v-if="dictCodeShow == 'LZDTH'">
                    ฿
                  </span>
                  <span v-if="dictCodeShow == 'LZDMY'">
                    RM
                  </span>
                  <span
                    v-if="dictCodeShow != 'LZDMY' && dictCodeShow != 'LZDTH' && dictCodeShow != 'LZDPH' && dictCodeShow != 'LZDID' && dictCodeShow != 'LZDSG' && dictCodeShow != 'LZDVN'">
                    ¥
                  </span>
                  {{ scope.row.price }}
                </div>


                <div v-if="scope.row.islowprice" class="islowpriceStyle"
                  style="width: 39px;float: right;margin: 3px 10px;">标低</div>
              </div>

              <div style="float: left;;width: 100%;">
                <div v-if="scope.row.availableprice" style="float: left;">
                  <span v-if="logintype !== 'KEFU' && bmcKefuid == '4581'">
                    ADI：
                  </span>
                  <span v-else>
                    到手价：
                  </span>
                  <span v-if="dictCodeShow == 'LZDVN'">
                    ₫
                  </span>
                  <span v-if="dictCodeShow == 'LZDSG'">
                    $
                  </span>
                  <span v-if="dictCodeShow == 'LZDID'">
                    Rp
                  </span>
                  <span v-if="dictCodeShow == 'LZDPH'">
                    ₱
                  </span>
                  <span v-if="dictCodeShow == 'LZDTH'">
                    ฿
                  </span>
                  <span v-if="dictCodeShow == 'LZDMY'">
                    RM
                  </span>
                  <span
                    v-if="dictCodeShow != 'LZDMY' && dictCodeShow != 'LZDTH' && dictCodeShow != 'LZDPH' && dictCodeShow != 'LZDID' && dictCodeShow != 'LZDSG' && dictCodeShow != 'LZDVN'">
                    ¥
                  </span>
                  {{ scope.row.availableprice }}
                </div>
                <div v-if="scope.row.availableislowprice" style="width: 51px;float: right;margin: 3px 10px;"
                  class="availableislowpriceStyle">
                  到手低
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="250">
            <template slot-scope="scope">
              <div v-show="scope.row.status == '上架'" class="have">上架</div>
              <div v-show="scope.row.status == '下架'" class="out">下架</div>
              <div v-show="scope.row.status == '已删除'" class="out">已删除</div>
              <div v-show="scope.row.status == '链接失效'" class="failure">链接失效</div>
              <div v-show="scope.row.ischange == '是'" slot="reference" style="cursor:pointer" class="haveImg"
                @click="changeClick(scope.row.itemid, scope.row.platform)">
                <img src="https://brm.olonger.com/ex-img/zhiwen-status.png" />
              </div>
              <div v-show="scope.row.camisreport" class="haveImg">
                <img src="https://hawksights.obs.cn-east-2.myhuaweicloud.com/ceshi/1572505655208.png" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="优惠说明" width="300">
            <template slot-scope="scope">
              <couponsStyle :couponsStyle="scope.row.couponsChildList" :couponsPlatform="scope.row.platform" />
              <i class="el-icon-error" style="float: right;margin-top: -24px;cursor: pointer;"
                v-show="scope.row.couponsChildList && scope.row.couponsChildList.length > 0 && logintype == 'KEFU'"
                @click="couponClick(scope.row.couponsChildList, scope.row.platform, scope.row.shopname, scope.row.wangwang)"></i>
              <!-- 优惠券超出部分 -->
            </template>
          </el-table-column>
          <el-table-column label="备注状态" width="150" v-if="logintype == 'KEFU'">
            <template slot-scope="scope">
              {{ scope.row.remark3 }}
            </template>
          </el-table-column>
          <el-table-column label="店铺/经销商" show-overflow-tooltip width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.shopname" class="align_left ellipsis">{{ scope.row.shopname }}</div>
              <div v-else class="align_left ellipsis">/</div>
              <div v-show="scope.row.wangwang && dictCodeShow == 'TBTM' || dictCodeShow == '1688'"
                class="align_left ellipsis">{{ scope.row.wangwang }}</div>
              <div class="tall_icon">
                <img :src='require("@/assets/img/platform/pla_" + scope.row.platform + ".png")' alt class="edit_icon" />
                <span style="margin-top: 8px;" class="shoptype green" v-show="scope.row.authorize">{{
                  scope.row.authorize }}</span>
                <ShopType style="margin-top: 8px;" :shoptype="scope.row.shoptype" v-if="scope.row.shoptype" />
              </div>
              <div class="align_left ellipsis">{{ scope.row.dealername }}</div>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.remark1">备注1：{{ scope.row.remark1 }}</span>
              <br />
              <span v-if="scope.row.remark2">备注2：{{ scope.row.remark2 }}</span>
              <br />
              <span v-if="scope.row.remark3">备注3：{{ scope.row.remark3 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="已拼件数" v-if="dictCodeShow == 'PDD'" prop="salevolume"></el-table-column>
          <el-table-column :label="dictCodeShow == '1688' || dictCodeShow == 'PDD' ? '评价数' : '累计评价'"
            v-if="dictCodeShow != 'DD'" prop="evaluate_num"></el-table-column>
          <el-table-column label="评论数" v-if="dictCodeShow == 'DD'" prop="evaluate_num"></el-table-column>
          <el-table-column prop="salevolume" label="月销量" width="100" v-if="dictCodeShow == 'TBTM'"></el-table-column>
          <el-table-column prop="salevolume" label="成交量" width="100" v-if="dictCodeShow == '1688'"></el-table-column>
          <el-table-column prop="area" label="发货地" width="150"
            v-if="dictCodeShow == 'TBTM' || dictCodeShow == '1688' || dictCodeShow == 'JD'"></el-table-column>
          <el-table-column prop="area" label="运费" width="150"
            v-if="dictCodeShow == 'TBTM' || dictCodeShow == 'DD' || dictCodeShow == '1688'">
            <template slot-scope="scope" v-if="scope.row.express_fee">
              {{ scope.row.express_fee }}
            </template>
          </el-table-column>
          <el-table-column label="数据更新时间" width="200px" fixed="right" class-name="lastTime">
            <template slot-scope="scope">
              <span v-show="scope.row.synchrotime">{{ scope.row.synchrotime | fullTime }}</span>
              <i class="el-icon-error" style="color:#f40b17;margin-left: 6px;cursor: pointer;"
                v-if="logintype != 'DEALER' && logintype != 'HCMSUB' && logintype != 'HCM' && logintype != 'SHOP'"
                @click="deletesRowShow(scope.row)"></i>
              <br>
              <el-popover placement="bottom" width="210" trigger="click">
                <div v-if="warehousePeople && warehousePeople[0]">
                  <div>
                    入库人：{{ warehousePeople[0].realname }}
                  </div>
                  <div>
                    入库时间：{{ warehousePeople[0].createtime | fullTime }}
                  </div>
                </div>
                <div v-else>
                  暂无数据
                </div>
                <el-button type="text" icon="el-icon-warning-outline" v-if="logintype == 'KEFU'" slot="reference"
                  @click="IncomingInformation(scope.row.itemid)">入库人信息</el-button>
              </el-popover>
              <br>
              <el-button type="text" v-if="dictCodeShow == 'TBTM'"
                @click="updatePlatform(scope.row.itemid, scope.row.platform)">更换平台</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <pagination v-if="tableList && tableList.length > 0" :currentPage="paginae.currentPage"
          :pageSizes="paginae.pageSizes" :total="paginae.total" @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"></pagination>
      </div>
    </section>
    <!--标签选择-->
    <el-dialog title="标签设置" :visible.sync="tagVisible" width="25%" class="setTag">
      <el-checkbox-group v-model="checkTagArry" size="mini">
        <el-checkbox border v-for="item in tag" :label="item" :key="item"
          style="margin-right: 5px;margin-bottom: 10px;">{{
            item }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" @click="updateTag" size="small">确 定</el-button>
        <el-button @click="tagVisible = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 指纹变化详情 -->
    <el-dialog title="指纹变化" :visible.sync="dialogTableVisible" width="640px">
      <div v-if="changeData.length == 2" style="height: 530px;overflow-y: auto;">

        <div style="margin-top: 10px;" v-if="changeData[1].itemtitle !== changeData[0].itemtitle">
          <div style="display: block;font-weight: 600;" size="mini" type="text">标题变动</div>
          <el-row style="color: #c6c6c6; margin-top: 5px;">
            <el-col :span="4">变更前:</el-col>
            <el-col :span="20" v-if="changeData[1].itemtitle">{{ changeData[1].itemtitle }}</el-col>
            <el-col :span="20" v-else>--</el-col>
          </el-row>
          <el-row style="margin-top: 5px;">
            <el-col style="color: #f00;" :span="4">变更后:</el-col>
            <el-col :span="20" v-if="changeData[0].itemtitle">{{ changeData[0].itemtitle }}</el-col>
            <el-col :span="20" v-else>--</el-col>
          </el-row>
        </div>

        <div style="margin-top: 10px;" v-if="changeData[1].subheading !== changeData[0].subheading">
          <div style="display: block;font-weight: 600;" size="mini" type="text">副标题变动</div>
          <el-row style="color: #c6c6c6; margin-top: 5px;">
            <el-col :span="4">变更前:</el-col>
            <el-col :span="20" v-if="changeData[1].subheading">{{ changeData[1].subheading }}</el-col>
            <el-col :span="20" v-else>--</el-col>
          </el-row>
          <el-row style="margin-top: 5px;">
            <el-col style="color: #f00;" :span="4">变更后:</el-col>
            <el-col :span="20" v-if="changeData[0].subheading">{{ changeData[0].subheading }}</el-col>
            <el-col :span="20" v-else>--</el-col>
          </el-row>
        </div>

        <div style="margin-top: 10px;" v-if="changeData[1].price !== changeData[0].price">
          <div style="display: block;font-weight: 600;" size="mini" type="text">标价变动</div>
          <el-row style="color: #c6c6c6; margin-top: 5px;">
            <el-col :span="4">变更前:</el-col>
            <el-col :span="20" v-if="changeData[1].price">{{ changeData[1].price }}</el-col>
            <el-col :span="20" v-else>--</el-col>
          </el-row>
          <el-row style="margin-top: 5px;">
            <el-col style="color: #f00;" :span="4">变更后:</el-col>
            <el-col :span="20" v-if="changeData[0].price">{{ changeData[0].price }}</el-col>
            <el-col :span="20" v-else>--</el-col>
          </el-row>
        </div>

        <div style="margin-top: 10px;" v-if="logoChange">
          <div style="display: block;font-weight: 600;" size="mini" type="text">主图变动</div>
          <el-row style="color: #c6c6c6; margin-top: 5px;">
            <el-col :span="4">变更前:</el-col>
            <el-col :span="8">
              <img style="width: 80px; height: 80px;" :src="changeData[1].logopicurl" alt />
            </el-col>
            <el-col style="color: #f00;" :span="4">变更后:</el-col>
            <el-col :span="8">
              <img style="width: 80px; height: 80px;" :src="changeData[0].logopicurl" alt />
            </el-col>
          </el-row>
        </div>

        <div style="margin-top: 10px;" v-if="SKUPirceChanged">
          <div style="display: block;font-weight: 600;" size="mini" type="text">SKU价格变动</div>
          <el-row style="color: #c6c6c6; margin-top: 5px;">
            <el-col :span="4">变更前:</el-col>
            <el-col :span="20">
              <span v-if="skuChangeData[0]" style="display: block;" v-for="(item, i) in skuChangeData[0]" :key="i">
                {{ item.skuname + '' + item.skuprice }}
              </span>
              <span v-else>
                --
              </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 5px;">
            <el-col style="color: #f00;" :span="4">变更后:</el-col>
            <el-col :span="20">
              <span v-if="skuChangeData[1]" style="display: block;" v-for="(item, i) in skuChangeData[1]" :key="i">
                {{ item.skuname + '' + item.skuprice }}
              </span>
              <span v-else>
                --
              </span>
            </el-col>
          </el-row>
        </div>

        <div style="margin-top: 10px;"
          v-if="changeData[1].discountchange && changeData[1].discountchange !== changeData[0].discountchange">
          <div style="display: block;font-weight: 600;" size="mini" type="text">优惠券变动</div>
          <el-row style="color: #c6c6c6; margin-top: 5px;">
            <el-col :span="4">变更前:</el-col>
            <el-col :span="20">
              <div v-if="changeData[1].discountchange" v-for="(item, i) in changeData[1].discountchange.split(';')"
                :key="i" class="discount" style="margin-right: 20px;">
                <div class="grayShop" style="height: 23px;line-height: 23px;">
                  {{ item }}
                </div>
              </div>
              <div v-else>
                --
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-top: 5px;">
            <el-col style="color: #f00;" :span="4">变更后:</el-col>
            <el-col :span="20">
              <div v-if="changeData[0].discountchange" v-for="(item, i) in changeData[0].discountchange.split(';')"
                :key="i" class="discount" style="margin-right: 20px;">
                <div class="grayShop" style="height: 23px;line-height: 23px;">
                  {{ item }}
                </div>
              </div>
              <div v-else>
                --
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
    <!--批量打标-->
    <el-dialog title="批量打标" :visible.sync="markingShow" width="360px" height="278" size="small">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="打标设置：" :label-width="formLabelWidth">
          <el-cascader filterable clearable size="small" v-model="changeProductid" :options="options2"
            :props="productidChildren2" collapse-tags @visible-change="getListBybmcid2" style="width: 100%;"
            :disabled="cascaderDisabled"></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="updateProductidByIprNewPluginListList">确 定</el-button>
        <el-button @click="markingShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
    <!--批量备注-->
    <el-dialog title="批量备注" :visible.sync="remakShow" width="360px" height="278" size="small">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="备注状态：" :label-width="formLabelWidth">
          <el-select v-model="changeRemake3" filterable placeholder="请选择" size="small">
            <el-option label="123" value="123"></el-option>
            <el-option label="个RJB" value="个RJB"></el-option>
            <el-option label="MT" value="MT"></el-option>
            <el-option label="TZ" value="TZ"></el-option>
            <el-option label="LZ" value="LZ"></el-option>
            <el-option label="PL" value="PL"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="updateComplainStatus">确 定</el-button>
        <el-button @click="remakShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
    <!--修改对应产品-->
    <el-dialog title="修改对应产品" :visible.sync="product.ifproduct" width="20%" height="278" size="small">
      <span>产品：</span>
      <el-cascader ref="cascaderAddr" :options="bmcid" :props="productClassifyName" v-model="cascaderVal"
        @change="bmcidConfire2" filterable size="small"></el-cascader>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="bmcidConfireChange">确 定</el-button>
        <el-button @click="product.ifproduct = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 更新设置-->
    <el-dialog title="更新设置" :visible.sync="updateSettingShow" width="960px" id="setTags">
      <div style="max-height: 720px;overflow:auto" v-loading="fontLoading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading">
        <div style="color: #303133;">更新方式</div>
        <div style="margin-top: 15px;margin-bottom: 20px;">
          <el-radio v-model="timeUpdate" label="0" size="mini">即刻更新</el-radio>
          <el-radio v-model="timeUpdate" label="1" size="mini">定时更新</el-radio>
          <el-radio v-model="timeUpdate" label="2" size="mini" v-if="dictCodeShow !== 'PDD'">固定周期更新</el-radio>
        </div>

        <timeDataSelector v-if="timeUpdate === '1'" size="small" :expireTimeOption='expireTimeOption' @dataFun="dataFun"
          @timeFun="timeFun" />

        <div v-if="timeUpdate === '2'" style="margin-bottom: 20px;">
          <el-checkbox-group v-model="changeDate">
            <el-checkbox v-for="item in dayDate" :label="item" :key="item">
              {{ item }}
            </el-checkbox>
          </el-checkbox-group>
          <el-time-select v-model="timeValue" :picker-options="{
            start: '00:00',
            step: '00:60',
            end: '23:00'
          }" style="margin-top: 20px;" size="mini" placeholder="选择时间">
          </el-time-select>
        </div>

        <div style="color: #303133;">更新内容</div>
        <div style="margin-top: 15px;margin-bottom: 20px;">
          <el-radio v-model="settingtype" label="0" size="mini" @change="empty()">全部未打标</el-radio>
          <el-radio v-model="settingtype" label="1" size="mini" @change="empty()">按售价表分类更新</el-radio>
          <el-radio v-model="settingtype" label="2" size="mini" @change="empty()">按产品信息更新</el-radio>
          <el-radio v-model="settingtype" label="3" size="mini" @change="empty()">按链接更新时间更新</el-radio>
          <el-radio v-model="settingtype" label="5" size="mini" @change="empty()">按店铺更新</el-radio>
          <el-radio v-model="settingtype" label="6" size="mini" @change="empty()">按当日失败更新</el-radio>
          <el-radio v-model="settingtype" label="7" size="mini" @change="empty()">按{{ $store.state.globalLowPrice
          }}更新</el-radio>
          <el-radio v-model="settingtype" label="8" size="mini" @change="empty()">按销量更新</el-radio>
        </div>
        <div v-show="settingtype == '1'">
          <el-checkbox-group v-model="checkboxGroup1" size="mini">
            <el-checkbox-button v-for="item in tableData" :label="item.id" :key="item.id">{{ item.productClassifyName
            }}</el-checkbox-button>
          </el-checkbox-group>
          <div v-if="tableData.length == 0">
            暂无数据
          </div>
        </div>
        <div v-show="settingtype == '2'">
          <el-row>
            <el-col :span="3">
              <div style="margin-top: 14px;margin-right: 10px;text-align: left;">
                产品信息
              </div>
            </el-col>
            <el-col :span="21">
              <span v-for="(item, i) of items" style="width: 450px;">
                <el-cascader filterable clearable style="width: 400px;margin-top: 10px;" size="small"
                  v-model="items[i].products" :options="options2" :props="productidChildren2"
                  @visible-change="getListBybmcid2"></el-cascader>
                <el-button type="text" @click="del(i)" icon="el-icon-circle-close"
                  style="margin-left: 10px;"></el-button>
                <br>
              </span>
            </el-col>
            <el-col :span="21" :offset="3" style="margin-top: 10px;margin-bottom: 10px;" id="setTagsAdd">
              <el-button @click="onAdd" style="width: 400px;" icon="el-icon-plus" size="small">添加</el-button>
            </el-col>
          </el-row>
        </div>
        <div v-show="settingtype == '3'">
          <el-date-picker v-model="linkUpdateTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" size="small" style="width: 400px;">
          </el-date-picker>
        </div>
        <div v-show="settingtype == '5'">
          <el-select v-model="shopValue" multiple filterable placeholder="请选择店铺" style="width: 400px;margin-top: 10px;"
            size="small">
            <el-option v-for="item in shopData" :key="item.id" :label="item.shopName" :value="item.shopName">
            </el-option>
          </el-select>
        </div>
        <div v-show="settingtype == '8'">
          更新数量大于<el-input v-model="salevolumeNight" placeholder="请输入大于0的数字" size="mini"
            style="width: 150px;margin: 0 10px 0 10px;" type="number"></el-input>的链接
        </div>
        <div style="text-align: right;" v-if="dictCodeShow != 'PDD'">
          <el-button type="text" @click="updateSettingSure(1)"
            v-show="settingtype != 0 && settingtype != 6 && settingtype != 7">
            <i class="el-icon-check" style="font-size: 18px;"></i>
          </el-button>
          <el-button type="text" @click="empty()" v-show="settingtype != 0 && settingtype != 6 && settingtype != 7">
            <i class="el-icon-close" style="font-size: 18px;"></i>
          </el-button>
        </div>
        <div style="text-align: right;" v-else>
          <el-button type="text" @click="updateSettingSure()">
            <i class="el-icon-check" style="font-size: 18px;"></i>
          </el-button>
          <el-button type="text" @click="empty()">
            <i class="el-icon-close" style="font-size: 18px;"></i>
          </el-button>
        </div>
        <div style="margin-top: 20px;margin-bottom: 15px;color: #303133;">更新情况预估</div>
        <div v-if="timeUpdate == 0">
          <div style="display: flex;">
            前方还有 <div style="font-size: 16px;text-align: center;margin-top: -3px;margin-left: 5px;margin-right: 5px;">
              {{ loadingcount }}</div>条链接待更新，预计<div
              style="font-size: 16px;text-align: center;margin-top: -3px;margin-left: 5px;margin-right: 5px;">
              {{ loadingtime }}</div>后开始更新
          </div>
          <div style="margin-bottom: 15px;">
            <div style="float: left;">
              <div style="float: left;">
                本次更新商品链接
              </div>
              <div
                style="font-size: 16px;text-align: center;margin-top: -3px;margin-left: 5px;margin-right: 5px;float: left;">
                {{ count }}
              </div>
              <div style="float: left;">
                条，预计更新用时为
              </div>
              <div style="font-size: 16px;text-align: center;margin-top: -3px;margin-left: 5px;float: left;">
                {{ time }}
              </div>
              <div style="float: left;">
                ，如需更新请点击确认后耐心等待，
              </div>

            </div>
            更新进度到更新记录中查看。
            <!-- 自动更新频次过高，会导致指纹变化标识不能点亮，请合理控制自动更新频率 -->
          </div>
        </div>
        <div v-if="timeUpdate == 1">
          <div style="display: flex;" v-if="dictCodeShow !== 'PDD'">
            定时更新暂无预估信息，具体链接数量及预计用时，到定时时间点查询呈现
          </div>
          <div v-if="dictCodeShow == 'PDD'">
            <div style="margin-bottom: 15px;">
              <div style="float: left;">
                <div style="float: left;">
                  本次更新商品链接
                </div>
                <div
                  style="font-size: 16px;text-align: center;margin-top: -3px;margin-left: 5px;margin-right: 5px;float: left;">
                  {{ count }}
                </div>
                <div style="float: left;">
                  条，预计更新用时为
                </div>
                <div style="font-size: 16px;text-align: center;margin-top: -3px;margin-left: 5px;float: left;">
                  {{ time }}
                </div>
                <div style="float: left;">
                  ，如需更新请点击确认后耐心等待，
                </div>

              </div>
              更新进度到更新记录中查看。
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="dictCodeShow != 'PDD'">
        <el-button type="primary" @click="determineUpdate" size="mini" :loading="UpdateLoading"
          :disabled="UpdateDisabled && timeUpdate != 1 && timeUpdate != 2"
          v-show="count != '0' || timeUpdate == 1 || timeUpdate == 2">确 定</el-button>
        <el-button @click="updateSettingShow = false" size="mini" type="TheCustom">取 消</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-else>
        <el-button type="primary" @click="determineUpdate" size="mini" :loading="UpdateLoading"
          :disabled="UpdateDisabled && timeUpdate != 2" v-show="count != '0' || timeUpdate == 2">确 定</el-button>
        <el-button @click="updateSettingShow = false" size="mini" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 截图设置 -->
    <el-dialog title="截图设置" :visible.sync="screenshotShow" width="960px" id="setTags">
      <div style="max-height: 720px;overflow:auto">
        <div style="color: #303133;">设置方式</div>
        <div style="margin-top: 15px;margin-bottom: 20px;">
          <el-radio v-model="autoScreenshot" label="0" size="mini">关</el-radio>
          <el-radio v-model="autoScreenshot" label="1" size="mini">全部违规</el-radio>
          <el-radio v-model="autoScreenshot" label="2" size="mini">授权店铺违规</el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateScreenshot" size="mini" :loading="screenshotLoading">确 定</el-button>
        <el-button @click="screenshotShow = false" size="mini" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 1药城Cookie录入 -->
    <el-dialog title="Cookie录入" :visible.sync="cookieShow" width="640px" id="setTags" :close-on-click-modal="false">
      <div>
        <el-form label-width="100px">
          <el-form-item label="Cookie" :required="true">
            <el-input placeholder="请输入" v-model.trim="CookieStr" clearable size="small">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cookieClick" size="mini" :disabled="cookieDisabled">确 定</el-button>
        <el-button @click="cookieShow = false" size="mini" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 设置 -->
    <el-dialog title="设置" :visible.sync="couponShow" width="640px" id="setTags" :close-on-click-modal="false">
      <div style="width: 100%;height: 25px;text-align: center;line-height: 25px;font-size: 18px;margin-bottom: 20px;">
        <i class="el-icon-warning" style="font-size: 25px;color: rgb(250, 173, 20);"></i>
        选择该店铺下要删除的所有同类型的优惠卷
      </div>
      <div style="margin-bottom: 20px;overflow: auto;">
        <div v-for="(item, index) in couponData" :key="index" class="discount">
          <div v-if="couponPlatform == 'DD'">
            <div v-if="item.category == 3" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>领劵 | {{ item.privilege }}</el-radio>
            </div>
            <div v-if="item.category == 6" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>满N件折 | {{ item.privilege }}</el-radio>
            </div>
            <div v-if="item.category == 10" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>满1件折 | {{ item.privilege }}</el-radio>
            </div>
            <div v-if="item.category == 7" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>店铺促销 | {{ item.privilege }}</el-radio>
            </div>
            <div v-if="item.category == 8" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>满额减 | {{ item.privilege }}</el-radio>
            </div>
            <div v-if="item.couponsType == 4" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>自定义 | {{ item.privilege }}</el-radio>
            </div>
          </div>

          <div v-if="couponPlatform != 'DD'">
            <div v-if="item.couponsType == 1">
              <div v-if="item.category == 1" style="margin-right: 10px;">
                <el-radio v-model="radiotype" :label="item.privilege" border>淘客券 | {{ item.privilege }}</el-radio>
              </div>
              <div v-if="item.category == 2 || item.category == '' || !item.category" style="margin-right: 10px;">
                <el-radio v-model="radiotype" :label="item.privilege" border>店铺优惠券 | {{ item.privilege }}</el-radio>
              </div>
              <div v-if="item.category == 3" style="margin-right: 10px;">
                <el-radio v-model="radiotype" :label="item.privilege" border>商品优惠券 | {{ item.privilege }}</el-radio>
              </div>
              <div v-if="item.category == 4" style="margin-right: 10px;">
                <el-radio v-model="radiotype" :label="item.privilege" border>品类购物券 | {{ item.privilege }}</el-radio>

              </div>
              <div v-if="item.category == 5" style="margin-right: 10px;">
                <el-radio v-model="radiotype" :label="item.privilege" border>关注店铺券 | {{ item.privilege }}</el-radio>
              </div>
              <div v-if="item.category == 9" style="margin-right: 10px;">
                <el-radio v-model="radiotype" :label="item.privilege" border>店铺活动券 | {{ item.privilege }}</el-radio>
              </div>
            </div>
            <div v-if="item.couponsType == 2" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>店铺活动 | {{ item.privilege }}</el-radio>
            </div>
            <div v-if="item.couponsType == 3" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>预售 | {{ item.privilege }}</el-radio>
            </div>
            <div v-if="item.couponsType == 4" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>自定义 | {{ item.privilege }}</el-radio>
            </div>
            <div v-if="item.couponsType == 5" style="margin-right: 10px;">
              <el-radio v-model="radiotype" :label="item.privilege" border>跨店满减 | {{ item.privilege }}</el-radio>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="margin-top: 20px;">
        <el-button type="primary" @click="deleteCouponsByShop" size="mini" :disabled="deleteCouponsDisabled">确
          定</el-button>
        <el-button @click="couponShow = false" size="mini" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 同步禁售链接 -->
    <el-dialog title="同步禁售链接" :visible.sync="SynchronizeShow" width="360px" style="margin-top: 10%;height: 346px;"
      :close-on-click-modal="false">
      <div style="display: flex;width: 100%;justify-content:center;line-height: 35px;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;margin-right: 10px;"></i>
        <div>
          <div style="font-size: 16px;">你确认要将选择的链接以禁售的方式同步到违规检索数据统计表中么？</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="syncDailyLowPriceban()" size="small">确 定</el-button>
        <el-button @click="SynchronizeShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取
          消</el-button>
      </div>
    </el-dialog>
    <!-- AI -->
    <el-dialog title="AI" :visible.sync="aiShow" width="720px" style="margin-top: 10%;max-height: 800px;"
      :close-on-click-modal="false">
      <el-tag type="warning" style="width: 100%;">
        <div style="float: left;width: 100%;white-space:nowrap;">
          <img src="../../../assets/img/other/trumpet_icon.png" style="margin: 9px 5px 0px 13px;float: left;">
          <div style="float: left;">
            请确认当前数据AI打标是否正确？
          </div>
        </div>
      </el-tag>
      <el-table ref="multipleTable2" :data="aiData" tooltip-effect="dark" style="width: 100%">
        <el-table-column align="left" type="index" width="50" fixed="left">
          <template slot-scope="scope">
            <img src="../../../assets/img/AI.png" alt="" style="width: 20px;height: 20px;float: right;cursor: no-drop;"
              v-if="scope.row.autotype == 1">
          </template>
        </el-table-column>
        <el-table-column prop="itemtitle" label="标题">
        </el-table-column>
        <el-table-column prop="productname" label="产品">
          <template slot-scope="scope">
            {{ scope.row.productname }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              v-if="scope.row.autotype == 1">正确</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)"
              v-if="scope.row.autotype == 1">错误</el-button>
            <el-tag type="danger" v-if="scope.row.autotype == 4" style="cursor: no-drop;">错误</el-tag>
            <el-tag type="success" v-if="scope.row.autotype == 3" style="cursor: no-drop;">正确</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="aiShow = false" style="margin-left: 10px;" size="small" type="TheCustom">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 提示-->
    <elementHint ref="hintCommon" :main="hint.main" @hintConfire="hintConfire" @hintShowCancel="hintShowCancel">
    </elementHint>
    <skuList ref="skuListChild" :dictCodeShow="dictCodeShow"></skuList>
    <!-- 打标修改 -->
    <el-dialog title="打标修改" :visible.sync="dbShow" width="360px" height="278" size="small">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="打标设置：" :label-width="formLabelWidth">
          <el-cascader filterable clearable size="small" v-model="changeProductid2" :options="options2"
            :props="productidChildren2" collapse-tags style="width: 100%;"
            @visible-change="getListBybmcid2"></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="errChange">确 定</el-button>
        <el-button @click="dbShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog>
    <batchMarkingChild type="single" :platform="this.aiPlatform" ref="batchMarkingChild"
      @parent-method="getIprPluginListList"></batchMarkingChild>
  </div>
</template>
<script>
import _ from 'lodash';
import pagination from "../../../components/dataTable/pagination";
import elementHint from "../../../components/dataTable/elementHint"; //提示
import tableHeader from "../../CreditScore/common/tableHeader"; //勾选全部
import ShopType from "@/components/shopType";
import couponsStyle from "@/components/couponsStyle";
import skuList from "./skuList"; //sku列表
import aes from "@/libs/aes";
import timeDataSelector from '../../../components/timeDataSelector/timeDataSelector';
import batchMarkingChild from './batchMarkingChild';

import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "brandStore",
  data: function () {
    return {
      aiItemid: '',
      aiPlatform: '',
      changeProductid2: [],
      aiIndex: 0,
      dbShow: false,
      aiDataArsew: {},
      multipleSelection: [],
      aiData: [],
      aiShow: false,
      complaintData: [],
      remakShow: false,
      showChange: true,
      autoScreenshot: '0',
      screenshotLoading: false,
      screenshotShow: false,
      pushMessageShow: false,
      salevolumeNight: '',
      deleteCouponsDisabled: false,
      couponPlatform: '',
      couponShow: false,
      shopValue: [],
      shopData: [],
      changeProductid: [],
      changeRemake3: '',
      timeValue: '',
      changeDate: [],
      dayDate: [
        '周一',
        '周二',
        '周三',
        '周四',
        '周五',
        '周六',
        '周日',
      ],
      divLoading: true,
      divShow: false,
      cascaderLoading: true,
      cascaderDisabled: false,
      cookidFont: '',
      CookieStr: '',
      btnName: '更新设置',
      newPlateList: [{
        dictCode: "TBTM",
        dictName: "淘宝天猫",
      }, {
        dictCode: "JD",
        dictName: "京东商城",
      }, {
        dictCode: "SN",
        dictName: "苏宁易购"
      }, {
        dictCode: "PDD",
        dictName: "拼多多"
      }, {
        dictCode: "1688",
        dictName: "1688"
      }, {
        dictCode: "DD",
        dictName: "当当网"
      }, {
        dictCode: "WPH",
        dictName: "唯品会",
        disabledshow: false,
      }, {
        dictCode: "YFW",
        dictName: "药房网",
        disabledshow: false,
      }, {
        dictCode: "YYC",
        dictName: "1药城",
        disabledshow: false,
      },
      // {
      //   dictCode: "LZDVN",
      //   dictName: "lazada-越南",
      //   disabledshow: false,
      // },{
      //   dictCode: "LZDSG",
      //   dictName: "lazada-新加坡",
      //   disabledshow: false,
      // },{
      //   dictCode: "LZDMY",
      //   dictName: "lazada-马来西亚",
      //   disabledshow: false,
      // },
      {
        dictCode: "DY",
        dictName: "抖音",
        disabledshow: false,
      },{
        dictCode: "XY",
        dictName: "闲鱼",
        disabledshow: false,
      },],
      dataId: '',
      disbutton: true,
      disbutton2: true,
      linkUpdateTime: '',
      timeUpdate: '0',
      fontLoading: true,
      dialogTableVisible: false,
      changeData: [],
      skuChangeData: [[], []],
      couponChangeData: [[], []],
      couponChanged: false,
      SKUPirceChanged: false,
      skuClass: '',
      logoChange: false,
      dataLoading: false,
      checkboxDisabled: false,
      judge: false,
      clearSet: '',
      updatetime: '',
      updateSetLoading: false,
      upDataIds: '',
      loadingcount: 0,
      loadingtime: '0分钟',
      count: 0,
      time: '0分钟',
      items: [{
        products: '',
      }],
      checkboxGroup1: [],
      settingtype: '0',
      updateSettingShow: false,
      selectAll: false,
      downTableTrue: false,
      platformCode: "TBTM",
      dictCodeShow: "TB",
      platformShow: true, //搜索框切换
      UpdateDisabled: true,
      UpdateLoading: false,
      notice_type: "",
      searchformDate: [],
      LowPriceLoading: false,
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() <= Date.now();
        }
      },
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick: (picker) => {
            this.getRecentDate(picker, 1);
          }
        }, {
          text: '近7日',
          onClick: (picker) => {
            this.getRecentDate(picker, 7);
          }
        }, {
          text: '近15日',
          onClick: (picker) => {
            this.getRecentDate(picker, 15);
          }
        }, {
          text: '近30日',
          onClick: (picker) => {
            this.getRecentDate(picker, 30);
          }
        }, {
          text: '近90日',
          onClick: (picker) => {
            this.getRecentDate(picker, 90);
          }
        }, {
          text: '近365日',
          onClick: (picker) => {
            this.getRecentDate(picker, 365);
          }
        }]
      },
      tableData: [],
      skuListData: [],
      //需要删除的信息
      delInfo: {
        checkAll: false,
        info: []
      },
      formLabelWidth: "100px",
      batchDisable: true,
      chekTableNum: {
        all: "",
        check: 0
      },
      logintype: "",
      hint: { main: "你确认将该商品移出商品库吗？" },
      cascaderVal: [],
      productClassifyName: {
        value: "id",
        label: "productClassifyName",
        children: "children"
      },
      productidChildren: {
        multiple: true,
        value: "id",
        label: "productClassifyName",
        children: "children"
      },
      productidChildren2: {
        value: "id",
        label: "productClassifyName",
        children: "children"
      },
      cHidden: false,
      query: {},
      activeKey: "",
      updataPer: "",
      successPer: "",
      changes: {},
      deletesRow: false,
      platformIcon: "",
      platformTM: "",
      bmcidChild: [],
      bmcid: [],
      options2: [],
      checkTagArry: [],
      tableList: [],
      warehousePeople: [],
      list: {
        pageNo: 1,
        pageSize: 10,
        platform: "TBTM",
        type: "", //排序
        itemtitle: "",
        lowprice: "",
        ischange: "",
        desc: "", //价格升序降序
        shopname: "", //店铺名称
        status: [], // 状态
        remark: "", // 备注
        productid: "", // 产品信息
        itemid: "",
        complaintStatus: "",
      },
      navCheck: 0, //选中的导航下标
      nav: ["淘宝天猫", "1688网", "京东商城", "苏宁易购", "当当网"],
      searchTag: false,
      visible3: false,
      tagVisible: false, //标签显示隐藏
      tag: [
        "主图违规",
        "满减违规",
        "活动违规",
        "赠品违规",
        "优惠券违规",
        "标题违规"
      ],
      product: {
        value: "",
        value2: "",
        ifproduct: false //对应产品显示隐藏
      },
      paginae: {
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
        total: 40
      },
      radio1: "",
      radio2: "",
      radio3: "",
      timeData: "",
      dateData: "",
      regulartime: "",
      pageConfig: {
        isPage: true,
        total: 0
      },
      source: null,
      cookieShow: false,
      cookieDisabled: false,
      userid: "",
      markingShow: false,
      couponData: [],
      couponShopname: '',
      couponsType: '',
      discountType: '',
      category: '',
      radiotype: '',
      SynchronizeShow: false,
      bmcKefuid: '',
    };
  },
  mounted() {
    console.log(localStorage.getItem('bmcKefuid'))
    this.logintype = JSON.parse(localStorage.getItem("userData")).logintype; //登录账号类型
    this.bmcKefuid = JSON.parse(localStorage.getItem("userData")).bmcid;
    if (this.logintype == 'KEFU') {
      this.selectAll = true
    }
    const usertype = localStorage.getItem("usertype");
    if (usertype == "c") this.cHidden = false;
    else this.cHidden = true;
    if (this.$route.query.platformCode) {
      if (this.$route.query.platformCode == 'TB' || this.$route.query.platformCode == 'TM') {
        this.activeKey = 'TBTM'
        this.list.platform = 'TBTM'
        let item = {}
        item.dictCode = 'TBTM'
        this.navChange(item)
      } else {
        this.activeKey = this.$route.query.platformCode;
        let item = {}
        item.dictCode = this.$route.query.platformCode
        this.navChange(item)
      }
    }
  },
  created() {
    this.getNavTitle();
  },
  computed: {
    ...mapGetters(["plateList"])
  },
  methods: {
    markingClick(data) {
      this.aiPlatform = data.platform
      this.$refs.batchMarkingChild.startChange(data.skuId, data.itemid, data.id)
    },
    handleEdit(index, data) {
      this.aiIndex = index
      let params = {
        itemid: data.itemid,
        platform: this.aiPlatform,
        productid: '',
      }
      if (data.skuId) {
        params.skuid = data.skuId
      } else {
        params.skuid = ''
      }
      this.aiDataArsew = params
      this.autotypeChange();
    },
    handleDelete(index, data) {
      this.changeProductid2 = []
      this.aiIndex = index
      this.dbShow = true;
      let params = {
        itemid: data.itemid,
        platform: this.aiPlatform,
      }
      if (data.skuId) {
        params.skuid = data.skuId
      } else {
        params.skuid = ''
      }
      this.aiDataArsew = params
    },
    errChange() {
      this.aiDataArsew.productid = this.changeProductid2[1].split(',')[0],
        this.autotypeChange();
    },
    autotypeChange() {
      fetch({
        url: "hcm/iprNewPluginList/updateAutotype",
        method: "post",
        params: this.aiDataArsew,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.aiData[this.aiIndex].autotype = res.data
          this.dbShow = false;
          // this.aiShow = false;
          this.huoquGetSkuList();
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    aiChange(data) {
      if (data.skulist) {
        this.aiItemid = data.skulist[0].numId
        this.aiPlatform = data.platform
        this.huoquGetSkuList()
      } else {
        this.aiData = []
        this.aiData.push(data)
        this.aiShow = true;
      }
    },
    huoquGetSkuList() {
      let params = {
        pageNo: 1,
        pageSize: 10000,
        itemid: this.aiItemid,
        platform: this.aiPlatform,
      }
      fetch({
        url: "hcm/iprNewPluginList/getSkuList", method: "get", params: params,
      }).then((res) => {
        if (res.status == '10000') {
          let data = res.data
          for (let a in data.content) {
            data.content[a].itemid = data.content[a].numId
            data.content[a].itemtitle = data.content[a].skuname
            data.content[a].platform = data.platform
          }
          this.aiData = res.data.content;
          this.aiShow = true;
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch((res) => {
        console.log(res, 'resresres')
        this.$message.error("请求出错！");
      })
    },
    // 拼多多跳转
    jumpPdd() {
      this.$router.push({
        path: '/keywordPdd', query: { platform: this.list.platform }
      })
    },
    getPddBmcid() {
      fetch({
        url: "/hcm/iprNewPluginList/getPddBmcid",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          console.log("拼多多更新设置", res.data)
          if (this.dictCodeShow == 'PDD') {
            this.showChange = true
            if (res.data == true) {
              this.showChange = false
            }
          } else {
            this.showChange = false
          }
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    updateScreenshot() {
      let params = {
        autoScreenshot: this.autoScreenshot,
      }
      this.screenshotLoading = true
      fetch({
        url: "hcm/cus/updateScreenshot",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.screenshotShow = false
          this.screenshotLoading = false
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    Synchronize() {
      this.SynchronizeShow = true
    },
    syncDailyLowPriceban() {
      if (this.delInfo.info.length == 0) {
        this.$message.warning("没有选择任何信息");
        return;
      }
      let that = this
      let newProductid2 = []
      let datas = {
        // changeProductid: this.changeProductid[1].split(',')[0],
      }
      if (this.delInfo.checkAll) {
        //全部删除
        datas.ids = "checkAll";
      } else {
        let arr = [];
        for (let item of this.delInfo.info) {
          arr.push(item.id);
        }
        datas.ids = arr.join(",");
      }
      if (that.list.platform) {
        datas.platform = that.list.platform;
      }
      if (that.radio3) {
        datas.ischange = that.radio3;
      }
      if (that.radio2) {
        datas.lowprice = that.radio2;
      }
      if (that.list.itemtitle) {
        datas.itemtitle = that.list.itemtitle;
      }
      if (that.list.shopname) {
        datas.shopname = that.list.shopname;
      }
      if (that.list.status) {
        datas.status = that.list.status.join();
      }
      if (that.list.type) {
        datas.type = that.list.type;
      }
      if (that.list.productid && that.list.productid.length > 0) {
        for (var a = 0; a < that.list.productid.length; a++) {
          if (that.list.productid[a][1]) {
            newProductid2.push(that.list.productid[a][1].split(",")[0])
          }
        }
        if (newProductid2.length > 0) {
          datas.productid = newProductid2.join(",")
        }
      }
      if (that.list.desc) {
        datas.desc = that.list.desc;
      }
      if (that.searchformDate) {
        if (that.searchformDate[0] && that.searchformDate[1]) {
          datas.starttime = that.$options.filters["fullTime"](
            that.searchformDate[0]
          ).substring(0, 10);
          datas.endtime = that.$options.filters["fullTime"](
            that.searchformDate[1]
          ).substring(0, 10);
        }
      }
      this.hcmBrmlogSave('synchronousban')
      fetch({
        url: "hcm/iprViolationRetrieveData/syncDailyLowPriceban",
        method: "post",
        data: datas,
        timeout: 60 * 1000 * 5
      })
        .then(res => {
          console.log(res)
          if (res.status == '10000') {
            this.$message({
              message: '设置成功',
              type: 'success'
            });
            this.SynchronizeShow = false

            this.getIprPluginListList()
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })
    },
    deleteCouponsByShop() {
      if (!this.radiotype) {
        this.$message({
          message: '请选择优惠券',
          type: "error"
        });
        return
      }
      this.deleteCouponsDisabled = true
      for (let a in this.couponData) {
        if (this.couponData[a].privilege == this.radiotype) {
          this.couponsType = this.couponData[a].couponsType
          this.discountType = this.couponData[a].discountType
          this.category = this.couponData[a].category
        }
      }
      let params = {
        shopname: this.couponShopname,
        couponsType: this.couponsType,
        discountType: this.discountType,
        category: this.category,
        platform: this.couponPlatform,
      }
      fetch({
        url: "hcm/iprNewPluginList/deleteCouponsByShop",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.couponShow = false
          this.deleteCouponsDisabled = false
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    finShopByNameal() {
      let params = {
        shopname: '',
        platform: this.list.platform,
      }
      fetch({
        url: "/hcm/hcmShop/finShopByNameal",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.shopData = []
          this.shopData = res.data
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    couponClick(data, platform, shopname, wangwang) {
      this.couponShow = true
      this.couponData = []
      this.couponPlatform = platform
      if (wangwang) {
        this.couponShopname = wangwang
      } else {
        this.couponShopname = shopname
      }
      this.couponData = data
    },
    // 批量打标
    updateProductidByIprNewPluginListList() {
      let that = this
      let newProductid2 = []
      let datas = {
        changeProductid: this.changeProductid[1].split(',')[0],
      }
      if (this.delInfo.checkAll) {
        //全部删除
        datas.ids = "checkAll";
      } else {
        let arr = [];
        for (let item of this.delInfo.info) {
          arr.push(item.id);
        }
        datas.ids = arr.join(",");
      }
      if (that.list.platform) {
        datas.platform = that.list.platform;
      }
      if (that.radio3) {
        datas.ischange = that.radio3;
      }
      if (that.radio2) {
        datas.lowprice = that.radio2;
      }
      if (that.list.itemtitle) {
        datas.itemtitle = that.list.itemtitle;
      }
      if (that.list.shopname) {
        datas.shopname = that.list.shopname;
      }
      if (that.list.status) {
        datas.status = that.list.status.join();
      }
      if (that.list.type) {
        datas.type = that.list.type;
      }
      if (that.list.productid && that.list.productid.length > 0) {
        for (var a = 0; a < that.list.productid.length; a++) {
          if (that.list.productid[a][1]) {
            newProductid2.push(that.list.productid[a][1].split(",")[0])
          }
        }
        if (newProductid2.length > 0) {
          datas.productid = newProductid2.join(",")
        }
      }
      if (that.list.desc) {
        datas.desc = that.list.desc;
      }
      if (that.list.itemid) {
        datas.itemid = that.list.itemid;
      }
      if (that.searchformDate) {
        if (that.searchformDate[0] && that.searchformDate[1]) {
          datas.starttime = that.$options.filters["fullTime"](
            that.searchformDate[0]
          ).substring(0, 10);
          datas.endtime = that.$options.filters["fullTime"](
            that.searchformDate[1]
          ).substring(0, 10);
        }
      }
      fetch({
        url: "hcm/iprNewPluginList/updateProductidByIprNewPluginListList",
        method: "post",
        data: datas,
        timeout: 60 * 1000 * 5
      })
        .then(res => {
          console.log(res)
          if (res.status == '10000') {
            this.$message({
              message: '设置成功',
              type: 'success'
            });
            this.gettbcookie()
            this.markingShow = false
            this.getIprPluginListList()
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })
    },
    // 批量备注
    updateComplainStatus() {
      let that = this
      let newProductid2 = []
      let datas = {
        changeRemake3: this.changeRemake3,
      }
      if (this.delInfo.checkAll) {
        //全部
        datas.ids = "checkAll";
      } else {
        let arr = [];
        for (let item of this.delInfo.info) {
          arr.push(item.id);
        }
        datas.ids = arr.join(",");
      }
      if (that.list.platform) {
        datas.platform = that.list.platform;
      }
      if (that.radio3) {
        datas.ischange = that.radio3;
      }
      if (that.radio2) {
        datas.lowprice = that.radio2;
      }
      if (that.list.itemtitle) {
        datas.itemtitle = that.list.itemtitle;
      }
      if (that.list.shopname) {
        datas.shopname = that.list.shopname;
      }
      if (that.list.status) {
        datas.status = that.list.status.join();
      }
      if (that.list.type) {
        datas.type = that.list.type;
      }
      if (that.list.productid && that.list.productid.length > 0) {
        for (var a = 0; a < that.list.productid.length; a++) {
          if (that.list.productid[a][1]) {
            newProductid2.push(that.list.productid[a][1].split(",")[0])
          }
        }
        if (newProductid2.length > 0) {
          datas.productid = newProductid2.join(",")
        }
      }
      if (that.list.desc) {
        datas.desc = that.list.desc;
      }
      if (that.list.itemid) {
        datas.itemid = that.list.itemid;
      }
      if (that.searchformDate) {
        if (that.searchformDate[0] && that.searchformDate[1]) {
          datas.starttime = that.$options.filters["fullTime"](
            that.searchformDate[0]
          ).substring(0, 10);
          datas.endtime = that.$options.filters["fullTime"](
            that.searchformDate[1]
          ).substring(0, 10);
        }
      }
      fetch({
        url: "hcm/iprNewPluginList/updateComplainStatus",
        method: "post",
        data: datas,
        timeout: 60 * 1000 * 5
      })
        .then(res => {
          console.log(res)
          if (res.status == '10000') {
            this.$message({
              message: '设置成功',
              type: 'success'
            });
            this.remakShow = false
            this.getIprPluginListList()
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })
    },
    marking() {
      if (this.delInfo.info.length == 0) {
        this.$message.warning("没有选择任何信息");
        return;
      }
      this.changeProductid = []
      this.markingShow = true
    },
    remakIng() {
      if (this.delInfo.info.length == 0) {
        this.$message.warning("没有选择任何信息");
        return;
      }
      this.remakShow = true
    },
    updatePlatform(itemid, platform) {
      let params = {
        itemid: itemid
      }
      if (platform == 'TM') {
        params.platform = 'TB'
      } else {
        params.platform = 'TM'
      }
      fetch({
        url: "hcm/iprNewPluginList/updatePlatform",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.getIprPluginListList(1)
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    gettbcookie() {
      let params = {
        platform: this.list.platform
      }
      fetch({
        url: "hcm/iprNewPluginList/gettbcookie",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          if (data.map.id) {
            this.cookidFont = ''
            this.userid = data.map.id
            if (data.map.cookie) {
              this.CookieStr = data.map.cookie
            } else {
              this.CookieStr = ''
            }
          } else {
            this.CookieStr = ''
          }
          if (data.status) {
            this.cookidFont = data.status
          } else if (data.map == '暂无cookie信息') {
            this.cookidFont = '暂无cookie信息'
          } else {
            this.cookidFont = ''
          }
          if (this.list.platform == 'TBTM') {
            // if (this.CookieStr != '' && this.cookidFont != "当前cookie已过期") {
            //   this.disbutton2 = false
            // } else {
            //   this.disbutton2 = true
            // }
          } else {
            this.disbutton2 = false
          }
          this.cookieTrue()
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
          this.cookieTrue()
        }
      })
    },
    // 定时更新时间
    timeFun(data) {
      this.timeData = data
    },
    // 定时更新日期
    dataFun(data) {
      this.dateData = data
    },
    // 入库信息
    IncomingInformation(itemid) {
      let params = {
        itemid: itemid,
      }
      fetch({
        url: "hcm/iprNewPluginList/getIprNewPluginStatisticsList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.warehousePeople = []
          this.warehousePeople = res.data
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    // 设置cookie
    cookieChange() {
      this.cookieShow = true
      this.gettbcookie()
    },
    cookieClick() {
      let datas = {}
      // if (this.CookieStr.indexOf('cna=') != -1 && this.list.platform = 'TBTM') {
      //   let CookieType = ''
      //   let CookieType2 = ''
      //   let CookieType3 = ''
      //   let arr = this.CookieStr.split(';')
      //   for (let a in arr) {
      //     if (arr[a].indexOf('cna=') != -1) {
      //       CookieType = arr[a]
      //     }
      //   }
      //   if (CookieType.indexOf('cookie: cna') != -1) {
      //     let arr2 = CookieType.split(': ')
      //     for (let b in arr2) {
      //       if (arr2[b].indexOf('cna=') != -1) {
      //         CookieType2 = arr2[b]
      //       }
      //     }
      //   }
      //   if (CookieType2 != '') {
      //     CookieType3 = CookieType2
      //   } else {
      //     CookieType3 = CookieType
      //   }
      //   datas.cookie = CookieType3
      //   datas.id = this.userid
      //   datas.platform = this.list.platform
      // } else
      if (this.list.platform == 'YYC') {
        let CookieType = ''
        if (this.CookieStr.indexOf('ycgltoken=') != -1) {
          CookieType = this.CookieStr.split('ycgltoken=')[1]
        } else if (this.CookieStr.indexOf('yc_pass_gltoken=') != -1) {
          CookieType = this.CookieStr.split('yc_pass_gltoken=')[1]
        } else {
          CookieType = this.CookieStr
        }
        datas.cookie = CookieType
        // datas.id = this.userid
        datas.platform = this.list.platform
      } else if (this.list.platform == 'TBTM') {
        datas.cookie = this.CookieStr
        // datas.id = this.userid
        datas.platform = this.list.platform
      }
      //  else {
      //   this.$message.error('cookie错误，请重新截取新cookie');
      //   return;
      // }
      this.savetbcookie(datas)

    },
    savetbcookie(datas) {
      fetch({
        url: "hcm/iprNewPluginList/savetbcookie",
        method: "post",
        data: datas,
        timeout: 60 * 1000 * 5
      })
        .then(res => {
          console.log(res)
          if (res.status == '10000') {
            this.$message({
              message: '设置成功',
              type: 'success'
            });
            this.cookieShow = false
            this.gettbcookie()
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })
    },
    // indexMethod(index) {
    //   let x = this.list.pageNo - 1
    //   return this.list.pageSize * x + index + 1;
    // },
    changeClick(itemid, platform) {
      let params = {
        platform: platform,
        itemid: itemid,
      }
      fetch({
        url: "hcm/iprNewPluginList/getItemChange",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.changeData = res.data
          if (this.changeData.length == 2) {
            this.dialogTableVisible = true
            this.isSKUPirceChanged(res.data);
          } else {
            console.log('是老数据不展示')
          }
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    isSKUPirceChanged(changeData) {
      this.SKUPirceChanged = false;
      this.logoChange = false;
      let oldItem = changeData[1];
      let newItem = changeData[0];

      let oldSkuDiff =
        _.differenceBy(oldItem.skuList, newItem.skuList, 'skuprice').length > 0
          ? _.differenceBy(oldItem.skuList, newItem.skuList, 'skuprice')
          : _.differenceBy(oldItem.skuList, newItem.skuList, 'skuname');
      let newSkuDiff =
        _.differenceBy(newItem.skuList, oldItem.skuList, 'skuprice').length > 0
          ? _.differenceBy(newItem.skuList, oldItem.skuList, 'skuprice')
          : _.differenceBy(newItem.skuList, oldItem.skuList, 'skuname');

      if (changeData[0].skuList.length !== changeData[1].skuList.length) {
        this.SKUPirceChanged = true;
      } else if (oldSkuDiff.length || newSkuDiff.length) {
        this.SKUPirceChanged = true;
      }
      this.skuChangeData[0] = oldSkuDiff;
      this.skuChangeData[1] = newSkuDiff;
      let newLogo = newItem.logopicurl.substring(
        newItem.logopicurl.lastIndexOf('/', newItem.logopicurl.lastIndexOf('/') - 1) + 1
      );
      let oldLogo = oldItem.logopicurl.substring(
        oldItem.logopicurl.lastIndexOf('/', oldItem.logopicurl.lastIndexOf('/') - 1) + 1
      );

      if (newLogo !== oldLogo) this.logoChange = true;
    },
    getnewweststate() {
      console.log(111)
      let params = {
        platform: this.list.platform,
      }
      fetch({
        url: "hcm/iprNewPluginList/getnewweststate",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        console.log(data)
        if (res.status == '10000') {
          this.updatetime = ''
          if (data) {
            // this.dataId = data.time.id
            this.dataId = data.id
            if (data.settingUpdateProgress || data.settingUpdateProgress == 0) {
              if (data.settingUpdateProgress == 0 || data.settingUpdateProgress == 1 || data.settingUpdateProgress == 4) {
                this.updateSetLoading = true
                this.btnName = '正在更新'
              } else {
                this.updateSetLoading = false
                this.btnName = '更新设置'
                clearInterval(this.clearSet)
              }
            }
            if (data.updatetime) {
              this.updatetime = data.updatetime
            } else {
              this.updatetime = ''
            }
          } else {
            this.updateSetLoading = false
            this.btnName = '更新设置'
            clearInterval(this.clearSet)
          }
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    // 固定周期更新
    determineUpdate() {
      if (!this.timeValue && this.timeUpdate == 2) {
        this.$message({
          message: '请选择时间',
          type: 'warning'
        });
        return
      }

      let that = this
      let productsArr = []
      let productname = []
      let datas = {
        platform: this.list.platform,
        updatecount: this.count,
        settingtype: this.settingtype,
      };
      if (this.timeUpdate != 2) {
        datas.type = this.timeUpdate
      }
      if (this.dataId && this.timeUpdate != 2) {
        datas.id = this.dataId
      }
      if (this.upDataIds != '') {
        datas.ids = this.upDataIds
      }
      // 为了拼多多加的可能只用半个月
      if (this.timeUpdate == 1) {
        this.regulartime = this.dateData + ' ' + this.timeData
        if (this.regulartime.length < 19) {
          this.$message({
            message: '定时更新请选择正确的时间',
            type: 'warning'
          });
          return;
        }
        datas.regulartime = this.regulartime
      }
      if (this.settingtype == '0') {
        // 更新内容全部商品
        datas.productname = ''
      } else
        // 为了拼多多加的可能只用半个月
        if (this.settingtype == '1') {
          // 更新内容售价表分类
          if (this.checkboxGroup1.length == 0) {
            this.$message({
              message: '请选择售价表分类',
              type: 'warning'
            });
            return;
          }
          for (var a = 0; a < this.tableData.length; a++) {
            for (var b = 0; b < this.checkboxGroup1.length; b++) {
              if (this.tableData[a].id === this.checkboxGroup1[b]) {
                productname.push(this.tableData[a].productClassifyName)
              }
            }
          }
          productsArr = this.checkboxGroup1
          datas.products = productsArr.join(",")
          datas.productname = productname.join(",")
        } else if (this.settingtype == '2') {
          // 更新内容产品信息
          for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].products[1]) {
              productsArr.push(this.items[i].products[1].split(",")[0]);
              productname.push(this.items[i].products[1].split(",")[1]);
            } else {
              this.$message({
                message: '请选择产品信息更新',
                type: 'warning'
              });
              return;
            }
          }
          datas.productname = productname.join(",")
          datas.products = productsArr.join(",")
        } else if (this.settingtype == '3') {
          // 更新内容链接更新时间
          datas.begintime = this.$options.filters['fullTime'](this.linkUpdateTime[0])
          datas.endtime = this.$options.filters['fullTime'](this.linkUpdateTime[1])
        } else if (this.settingtype == '5') {
          // 更新内容链接更新时间
          datas.shopnames = this.shopValue.join(",")
        } else if (this.settingtype == '8') {
          // 更新内容链接更新时间
          datas.salevolume = this.salevolumeNight
        }
      let newUrl
      if (this.timeUpdate == 2) {
        if (this.changeDate.length == 0) {
          this.$message({
            message: '请选择星期更新时间',
            type: 'warning'
          });
          return;
        }
        datas.regulartime = this.timeValue + ':00'
        if (this.changeDate != 0 && this.changeDate.indexOf('周一') != -1) {
          datas.monday = 1
        } else {
          datas.monday = 0
        }
        if (this.changeDate != 0 && this.changeDate.indexOf('周二') != -1) {
          datas.tuesday = 1
        } else {
          datas.tuesday = 0
        }
        if (this.changeDate != 0 && this.changeDate.indexOf('周三') != -1) {
          datas.wednesday = 1
        } else {
          datas.wednesday = 0
        }
        if (this.changeDate != 0 && this.changeDate.indexOf('周四') != -1) {
          datas.thursday = 1
        } else {
          datas.thursday = 0
        }
        if (this.changeDate != 0 && this.changeDate.indexOf('周五') != -1) {
          datas.friday = 1
        } else {
          datas.friday = 0
        }
        if (this.changeDate != 0 && this.changeDate.indexOf('周六') != -1) {
          datas.saturday = 1
        } else {
          datas.saturday = 0
        }
        if (this.changeDate != 0 && this.changeDate.indexOf('周日') != -1) {
          datas.sunday = 1
        } else {
          datas.sunday = 0
        }
        newUrl = 'hcm/iprNewPluginList/saveIprNewPluginListSettingFixed'
      } else {
        newUrl = 'hcm/iprNewPluginList/saveIprNewPluginListSetting'
      }
      this.UpdateLoading = true
      this.UpdateDisabled = true
      axios({
        method: 'post',
        url: newUrl,
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        },
        data: datas,
      }).then(function (response) {
        if (response.data.status == "10000") {
          that.updateSettingShow = false
          that.clearSet = setInterval(() => {
            that.getnewweststate();
          }, 5000)
          that.$message({
            type: "success",
            message: "操作成功!"
          });
          that.UpdateDisabled = false
          this.UpdateLoading = false
        } else {
          that.$message.error(response.data.message)
          that.UpdateDisabled = false
          that.UpdateLoading = false
        }
      })
    },
    // 产品信息
    oneStep() {
      let params = {
        pageNum: 1,
        pageSize: 200
      }
      fetch({
        url: "hcm/ProductClassify/seletProductClassify",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.tableData = data.data.list;
          this.tableData.push({
            productClassifyName: '全部'
          });
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    // 更新进程
    updateProcess() {
      this.$router.push({
        path: '/updateProcess', query: { platform: this.list.platform }
      })
    },
    // 待获取详情链接
    forMoreLinks() {
      this.$router.push({
        path: '/forMoreLink',
        query: { platform: this.platformCode }
      })
    },
    //删除
    del(index) {
      if (this.items.length == 1) {
        this.$message({
          showClose: true,
          message: '最少保留一条',
          type: 'error'
        });
      } else {
        this.items.splice(index, 1);
      }
    },
    // 新增
    onAdd() {
      this.items.push({
        products: '',
      })
    },
    // 更新设置
    updateSettings() {
      this.UpdateDisabled = true
      this.updateSettingShow = true
      this.oneStep()
      this.shopValue = []
      this.settingtype = '0'
      this.salevolumeNight = ''
      console.log(this.settingtype)
      // 为了拼多多加的可能只用半个月
      if (this.dictCodeShow != 'PDD') {
        if (this.settingtype == '0') {
          this.updateSettingSure(1)
        }
      } else {
        this.fontLoading = false
      }
      // 为了拼多多加的可能只用半个月
      // if (this.settingtype == '0') {
      //   this.updateSettingSure(1)
      // }
    },
    // 清空
    empty() {
      this.loadingcount = '0'
      this.loadingtime = '0分钟'
      this.count = '0'
      this.time = '0分钟'
      this.checkboxGroup1 = []
      this.items = []
      this.items.push({
        products: '',
      })
      console.log(this.dictCodeShow)
      // 为了拼多多加的可能只用半个月
      if (this.dictCodeShow != 'PDD') {
        if (this.settingtype == '0' || this.settingtype == '6' || this.settingtype == '7') {
          this.updateSettingSure(1)
        } else if (this.settingtype == '5') {
          this.finShopByNameal()
        }
      }
      // 为了拼多多加的可能只用半个月
      // if (this.settingtype == '0' || this.settingtype == '6' || this.settingtype == '7') {
      //   this.updateSettingSure(1)
      // }
    },
    // 确认更新时间
    updateSettingSure(e) {
      for (let a in this.checkboxGroup1) {
        if (this.checkboxGroup1[a] == undefined) {
          this.settingtype = 4
        }
      }
      let productsArr = []
      let params = {
        settingtype: this.settingtype,
        platform: this.list.platform,
      }
      // 为了拼多多加的可能只用半个月
      if (this.dictCodeShow == 'PDD') {
        // if (!this.regulartime) {
        //   return;
        // }
        console.log(this.timeUpdate)
        if (this.timeUpdate == '1') {
          if (!this.dateData || !this.timeData) {
            this.$message({
              message: '请先选择时间',
              type: 'warning'
            });
            return;
          } else {
            params.regulartime = this.dateData + ' ' + this.timeData
          }
        }
      }


      // 为了拼多多加的可能只用半个月
      if (this.settingtype == '1') {
        if (this.checkboxGroup1.length == 0) {
          this.$message({
            message: '请选择售价表分类',
            type: 'warning'
          });
          return;
        }
        productsArr = this.checkboxGroup1
        params.products = productsArr.join(",")
      } else if (this.settingtype == '2') {
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].products[1]) {
            productsArr.push(this.items[i].products[1].split(",")[0]);
          } else {
            this.$message({
              message: '请选择产品信息更新',
              type: 'warning'
            });
            return;
          }
        }
        params.products = productsArr.join(",")
      } else if (this.settingtype == '3') {
        console.log(this.linkUpdateTime)
        if (!this.linkUpdateTime) {
          this.$message({
            message: '请选择链接更新时间更新',
            type: 'warning'
          });
          return;
        }
        params.begintime = this.$options.filters['fullTime'](this.linkUpdateTime[0])
        params.endtime = this.$options.filters['fullTime'](this.linkUpdateTime[1])
        params.products = ''
      } else if (this.settingtype == '5') {
        if (this.shopValue.length == 0) {
          this.$message({
            message: '请选择店铺信息更新',
            type: 'warning'
          });
          return;
        }
        params.shopnames = this.shopValue.join(",")
      } else if (this.settingtype == '8') {
        if (!this.salevolumeNight) {
          this.$message({
            message: '请输入大于0的数字',
            type: 'warning'
          });
          return;
        }
        params.salevolume = this.salevolumeNight
      }
      fetch({
        url: "hcm/iprNewPluginList/getupdatesituation",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.fontLoading = false
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.loadingcount = data.loadingcount

          if (data.loadingtime < 60) {
            this.loadingtime = data.loadingtime + '秒钟'
          } else {
            let z
            z = data.loadingtime / 60
            this.loadingtime = Math.ceil(z) + '分钟'
          }
          this.count = data.count
          if (data.time < 60) {
            this.time = data.time + '秒钟'
          } else {
            let n
            n = data.time / 60
            this.time = Math.ceil(n) + '分钟'
          }
          this.upDataIds = data.ids
          if (data.count === 0) {
            this.UpdateDisabled = true
          } else {
            this.UpdateDisabled = false
          }
          // 为了拼多多加的可能只用半个月
          if (data.updateStatus && data.updateStatus == "本次更新超出数量") {
            this.UpdateDisabled = true
            this.$message({
              message: '本次更新超出数量',
              type: 'warning'
            });
            return;
          }
          // 为了拼多多加的可能只用半个月
        } else {
          this.fontLoading = false
          this.$message({
            message: res.message,
            type: 'warning'
          });
        }
      })
    },
    handleChange(value) {
      this.list.productid = value
    },
    hcmBrmlogSave(data) {
      //标签设置
      let that = this;
      let datas = {
        modlename: data
      };
      fetch({
        url: "hcm/hcmBrmlog/save",
        method: "post",
        data: datas,
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {

        }
      });
    },
    // 同步违规至每日检索
    syncDailyLowPrice() {
      this.LowPriceLoading = true
      let params = {
        platformCode: this.platformCode
      };
      if (this.dictCodeShow && this.dictCodeShow == "TBTM") {
        params.platformcode = "TBTM";
      } else {
        params.platformcode = this.dictCodeShow;
      }
      this.hcmBrmlogSave('synchronous')
      fetch({
        url: "hcm/iprViolationRetrieveData/syncDailyLowPrice",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text",
        timeout: 60 * 1000 * 10
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.$message({
            message: "同步成功",
            type: "success"
          });
          this.LowPriceLoading = false
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
          this.LowPriceLoading = false
        }
      });
    },
    // 前三个月时间
    getRecentDate(picker, n) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if (picker) {
        picker.$emit('pick', [start, end]);
      }
      if (n === 1) {
        this.searchformDate[0] = end;
        this.searchformDate[1] = end;
      } else {
        this.searchformDate[0] = start;
        this.searchformDate[1] = end;
      }
    },
    // 近三日时间
    getRecentDate2(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
      if (picker) {
        picker.$emit("pick", [start, end]);
      }
      this.searchformDate[0] = start;
      this.searchformDate[1] = end;
    },
    // 近七日时间
    getRecentDate3(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      if (picker) {
        picker.$emit("pick", [start, end]);
      }
      this.searchformDate[0] = start;
      this.searchformDate[1] = end;
    },
    // 近15日时间
    getRecentDate4(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
      if (picker) {
        picker.$emit("pick", [start, end]);
      }
      this.searchformDate[0] = start;
      this.searchformDate[1] = end;
    },
    // 近30日时间
    getRecentDate5(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      if (picker) {
        picker.$emit("pick", [start, end]);
      }
      this.searchformDate[0] = start;
      this.searchformDate[1] = end;
    },
    // 今日时间
    getRecentDate6(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
      if (picker) {
        picker.$emit("pick", [start, end]);
      }
      this.searchformDate[0] = end;
      this.searchformDate[1] = end;
    },
    ...mapActions(["reqPlateList"]),
    delBatches() {
      if (this.delInfo.info.length == 0) {
        this.$message.warning("没有选择任何信息");
        return false;
      }
      this.$refs.hintCommon.ifsee();
    },
    skuListChildShow(id, platform) {
      console.log(platform);
      let that = this;
      this.skuData = {
        itemid: id,
        platform: platform,
        pageNo: 1,
        pageSize: 10000
      };
      //显示sku弹窗
      this.$refs.skuListChild.dialogVisibleShow();
      this.$refs.skuListChild.getSkuList(this.skuData);
    },
    selectionChange(data) {
      this.delInfo.info = data; //需要删除的行
      console.log(data);
      this.chekTableNum.check = data.length;
      //存储是否全选
      if (data.length === this.tableList.length) {
        this.delInfo.checkAll = false; //全选
      } else {
        this.delInfo.checkAll = false;
      }
    },
    toggleSelection(rows, all) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        //不是勾选全部
        this.$refs.multipleTable.clearSelection();
        this.$set(this, "batchDisable", true);
        this.delInfo.checkAll = false;
        this.$set(this.chekTableNum, "check", 0);
      }
      if (all) {
        //勾选全部
        this.$set(this.chekTableNum, "check", this.paginae.total);
        this.$set(this, "batchDisable", false);
        this.delInfo.checkAll = true;
      }
    },
    getNavTitle() {
      this.reqPlateList();
    },
    hintShowCancel() {
      this.$refs.hintCommon.ifsee();
    },
    GetPercent(num, total) {
      //计算百分比
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0
        ? "0%"
        : Math.round((num / total) * 10000) / 100.0 + "%";
    },
    cancelRequest() {
      if (typeof this.source === "function") {
        this.source("终止请求"); //取消请求
      }
    },
    getListBybmcid2(data) {
      if (data == true && this.options2.length == 0) {
        this.divLoading = true
        this.cascaderDisabled = true
        this.divShow = true
        fetch({
          url: "hcm/hcmProduct/getListBybmcid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            this.options2 = result.data;
            this.cascaderDisabled = false
            this.divShow = false
          }
        });
      }
    },
    getIprPluginListList(e) {
      this.dataLoading = true
      this.checkTagArry = [];
      let that = this;
      let newProductid = [];
      if (this.radio1 == "按价格降序") {
        that.list.desc = "降序";
      }
      if (this.radio1 == "按价格升序") {
        that.list.desc = "";
      }
      if (this.radio1 == "") {
        that.list.desc = "";
      }
      if (e == 1) {
        this.paginae.currentPage = 0;
        this.list.pageNo = 1;
      }
      let datas = {
        pageNo: that.list.pageNo,
        pageSize: that.list.pageSize,
        platform: that.list.platform
      };
      if (that.radio3) {
        datas.ischange = that.radio3;
      }
      if (that.radio2) {
        datas.lowprice = that.radio2;
      }
      if (that.list.itemtitle) {
        datas.itemtitle = that.list.itemtitle;
      }
      if (that.list.shopname) {
        datas.shopname = that.list.shopname;
      }
      if (that.list.status) {
        datas.status = that.list.status.join();
      }
      if (that.list.desc) {
        datas.desc = that.list.desc;
      }
      if (that.list.remark) {
        datas.remark = that.list.remark;
      }
      if (that.list.itemid) {
        datas.itemid = that.list.itemid;
      }
      if (that.list.type) {
        datas.type = that.list.type;
      }
      if (that.list.complaintStatus) {
        datas.complaintStatus = that.list.complaintStatus;
      }

      if (that.list.productid && that.list.productid.length > 0) {
        for (var a = 0; a < that.list.productid.length; a++) {
          if (that.list.productid[a][1]) {
            newProductid.push(that.list.productid[a][1].split(",")[0])
          }
        }
        if (newProductid.length > 0) {
          datas.productid = newProductid.join(",")
        }
      }
      if (that.searchformDate) {
        if (that.searchformDate[0] && that.searchformDate[1]) {
          datas.starttime = that.$options.filters["fullTime"](
            that.searchformDate[0]
          ).substring(0, 10);
          datas.endtime = that.$options.filters["fullTime"](
            that.searchformDate[1]
          ).substring(0, 10);
        }
      }
      fetch({
        url: "hcm/iprNewPluginList/getIprNewPluginListList",
        method: "post",
        data: datas,
        timeout: 60 * 1000 * 5
      })
        .then(res => {
          let data = res.data;
          if (res.status == "10000") {
            this.gettbcookie()
            this.disbutton = false
            that.tableList = [];
            this.tableList = data.content;
            that.paginae.total = data.totalElements;
            this.dataLoading = false
            if (data.obj && data.obj.screenshotStatus) {
              this.autoScreenshot = data.obj.screenshotStatus
            } else {
              this.autoScreenshot = '0'
            }
            // loading.close();
            this.paginae.currentPage = 1;
            for (let i in data.content) {
              //标签
              if (data.content[i].tag && data.content[i].tag != 0) {
                let tagArr = data.content[i].tag.split(",");
                data.content[i].tag = tagArr;
              }
            }
            for (let i in data.content) {
              if (data.content[i].discount && data.content[i].discount != 0) {
                let discountArr = data.content[i].discount.split(";");
                data.content[i].discount = discountArr;
              }
            }

            //随平台变化
            this.changes = data.obj;
            // this.updataPer = this.GetPercent(
            //   this.changes.isupdatecount,
            //   this.changes.allcount
            // ); //今日更新率
            // let a = this.changes.allcount - this.changes.errorcount;
            // this.successPer = this.GetPercent(a, this.changes.allcount); //更新成功率
            this.chekTableNum.all = data.totalElements;
            this.getnewweststate();
          }
        })
        .catch(err => {
          this.chekTableNum.all = 0;
          this.dataLoading = false
        });
    },
    cookieTrue() {
      console.log(this.cookidFont != "当前cookie已过期")
      if (this.list.platform == 'YYC') {
        if (this.CookieStr != '' && this.cookidFont != "当前cookie已过期") {
          this.disbutton2 = false
        } else {
          this.disbutton2 = true
        }
      } else {
        this.disbutton2 = false
      }
    },
    deltetSearchTag() {
      this.radio1 = "";
      this.radio2 = "";
      this.radio3 = "";
      this.getIprPluginListList();
    },
    navChange(item) {
      console.log(item)
      this.LowPriceLoading = false
      this.UpdateLoading = false
      this.dictCodeShow = item.dictCode;
      if (item.dictCode == "TBTM") {
        this.platformShow = true;
        this.platformCode = "TBTM";
        this.activeKey = "TBTM";
        this.list.platform = item.dictCode;
      } else {
        this.platformCode = item.dictCode;
        this.activeKey = item.dictCode;
        this.platformShow = false;
        this.list.platform = item.dictCode;
      }
      console.log(this.list.platform);
      if (this.dictCodeShow == 'PDD') {
        this.getPddBmcid()
      } else {
        this.showChange = false
      }
      //导航切换
      this.list.pageNo = 1;
      this.list.pageSize = 10;
      this.paginae.currentPage = 0;
      this.getIprPluginListList();
    },
    handleSizeChange(val) {
      //每页
      this.list.pageSize = val;
      this.getIprPluginListList();
    },
    handleCurrentChange(val) {
      //当前页
      this.list.pageNo = val;
      this.getIprPluginListList();
    },
    editTag(id, index) {
      this.checkTagArryHave(index);
      //编辑标签
      this.tagVisible = true;
      this.id = id;
    },
    updateTag() {
      //标签设置
      let that = this;
      let datas = {
        id: this.id,
        platform: that.activeKey,
        tag: this.checkTagArry.join(",")
      };
      fetch({
        url: "hcm/iprPluginList/updateTag",
        method: "post",
        data: datas,
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {
          that.getIprPluginListList();
          that.tagVisible = false;
          that.$message({ type: "success", message: "设置成功" });
        }
      });
    },
    getListBybmcid(id, product_id) {
      this.id = id;
      this.product_id = product_id;
      let that = this;
      this.product.ifproduct = true;
      //编辑产品信息
      fetch({
        url: "hcm/hcmProduct/getListBybmcid",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {
          that.bmcid = result.data;
          console.log(result.data);
        }
      });
    },
    bmcidFirstChange() {
      this.bmcidChild = this.bmcid[this.product.value].children;
      this.product.value2 = "";
    },
    bmcidConfire2() {
      let data = {
        platform: this.activeKey,
        id: this.id
      };
      var breakUp = "";
      breakUp = this.cascaderVal[1].split(",");
      data.productname = breakUp[1];
      data.product_id = breakUp[0];
      this.changePro = data;
    },
    bmcidConfireChange() {
      if (this.cascaderVal.length == 0) {
        this.$message({ type: "warning", message: "请选择对应产品" });
        return false;
      }
      this.updateProductHttp();
    },
    bmcidConfire() {
      let index1 = this.product.value;
      let index2 = this.product.value2;
      if (index1 === "") {
        this.$message({ type: "warning", message: "请选择对应产品" });
        return false;
      }
      if (index2 === "" && this.bmcidChild != null) {
        this.$message({ type: "warning", message: "请选择对应产品" });
        return false;
      }
      let that = this;
      let productname;
      if (this.bmcidChild) {
        productname = `${this.bmcid[index1].productClassifyName}/${this.bmcid[index1].children[index2].productClassifyName}`;
      } else {
        productname = `${this.bmcid[index1].productClassifyName}`;
      }
      let data = {
        product_id: this.product_id,
        platform: that.activeKey,
        id: this.id,
        productname: productname
      };
      fetch({
        url: "hcm/iprPluginList/updateProduct",
        method: "post",
        data: data,
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {
          that.product.ifproduct = false;
          that.getIprPluginListList();
          that.$message({ type: "success", message: "修改成功" });
          that.product.value = "";
          that.product.value2 = "";
        }
      });
    },
    updateProductHttp() {
      fetch({
        url: "hcm/iprPluginList/updateProduct",
        method: "post",
        data: this.changePro
      }).then(res => {
        let result = res;
        if (result.status == "10000") {
          this.product.ifproduct = false;
          this.getIprPluginListList();
          this.$message({ type: "success", message: "修改成功" });
          this.changePro = {};
          this.cascaderVal = [];
        }
      });
    },
    deletesRowShow(data) {
      let arr = [];
      arr.push(data);
      this.delInfo.info = arr;
      this.$refs.hintCommon.ifsee();
      console.log(this.delInfo.info);
    },
    hintConfire() {
      let newProductid = [];
      //删除数据
      let data = {
        lowprice: this.radio2,
        ischange: this.radio3,
      };
      if (this.list.itemtitle) {
        data.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname) {
        data.shopname = this.list.shopname;
      }
      if (this.list.desc) {
        data.desc = this.list.desc;
      }
      if (this.list.remark) {
        data.remark = this.list.remark;
      }
      if (this.list.complaintStatus) {
        data.complaintStatus = this.list.complaintStatus;
      }
      if (this.list.productid && this.list.productid.length > 0) {
        for (var a = 0; a < this.list.productid.length; a++) {
          if (this.list.productid[a][1]) {
            newProductid.push(this.list.productid[a][1].split(",")[0])
          }
        }
        if (newProductid.length > 0) {
          data.productid = newProductid.join(",")
        }
      }
      if (this.searchformDate) {
        if (this.searchformDate[0] && this.searchformDate[1]) {
          data.starttime = this.$options.filters["fullTime"](
            this.searchformDate[0]
          ).substring(0, 10);
          data.endtime = this.$options.filters["fullTime"](
            this.searchformDate[1]
          ).substring(0, 10);
        }
      }
      if (this.list.status) {
        data.status = this.list.status.join();
      }
      if (this.list.platform) {
        data.platform = this.list.platform;
      }
      if (this.delInfo.checkAll) {
        //全部删除
        data.ids = "checkAll";
      } else {
        let arr = [];
        for (let item of this.delInfo.info) {
          arr.push(item.id);
        }
        data.ids = arr.join(",");
      }
      console.log(data)
      fetch({
        // url: "hcm/iprPluginList/updateStop",
        url: "hcm/iprNewPluginList/delete",
        method: "post",
        data: data,
        timeout: 60 * 1000 * 5
      }).then(res => {
        if (res.status == "10000") {
          this.deletesRow = false;
          this.getIprPluginListList();
          this.$refs.hintCommon.closeifsee();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          this.$message.warning("删除失败");
          this.$refs.hintCommon.closeifsee();
        }
      });
    },
    downTable(row) {
      let newProductid2 = []
      let that = this;
      that.downTableTrue = true
      if (this.radio1 == "按价格降序") {
        that.list.desc = "降序";
      }
      if (this.radio1 == "按价格升序") {
        that.list.desc = "升序";
      }
      if (this.radio1 == "") {
        that.list.desc = "";
      }
      let datas = {
        pageNo: that.list.pageNo,
        pageSize: that.list.pageSize,
        platform: that.list.platform
      };
      if (that.radio3) {
        datas.ischange = that.radio3;
      }
      if (that.radio2) {
        datas.lowprice = that.radio2;
      }
      if (that.list.itemtitle) {
        datas.itemtitle = that.list.itemtitle;
      }
      if (that.list.shopname) {
        datas.shopname = that.list.shopname;
      }
      if (that.list.status) {
        datas.status = that.list.status.join();
      }
      if (that.list.type) {
        datas.type = that.list.type;
      }
      if (that.list.productid && that.list.productid.length > 0) {
        for (var a = 0; a < that.list.productid.length; a++) {
          if (that.list.productid[a][1]) {
            newProductid2.push(that.list.productid[a][1].split(",")[0])
          }
        }
        if (newProductid2.length > 0) {
          datas.productid = newProductid2.join(",")
        }
      }
      if (that.list.desc) {
        datas.desc = that.list.desc;
      }
      if (that.searchformDate) {
        if (that.searchformDate[0] && that.searchformDate[1]) {
          datas.starttime = that.$options.filters["fullTime"](
            that.searchformDate[0]
          ).substring(0, 10);
          datas.endtime = that.$options.filters["fullTime"](
            that.searchformDate[1]
          ).substring(0, 10);
        }
      }
      if (this.delInfo.checkAll) {
        datas.ids = "checkAll";
      } else if (this.delInfo.info.length == 0) {
        datas.ids = "checkAll";
      } else {
        let arr = [];
        for (let item of this.delInfo.info) {
          arr.push(item.id);
        }
        datas.ids = arr.join(",");
      }
      fetch({
        url: "hcm/iprNewPluginList/down_IprNewPluginList2",
        method: "post",
        data: datas,
        noFormat: true,
        responseType: "blob",
        timeout: 60 * 1000 * 60
      }).then(res => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "品牌商品库.xlsx");
        document.body.appendChild(link);
        link.click();
        that.downTableTrue = false
      });
    },
    checkTagArryHave(index) {
      if (typeof this.tableList[index].tag != "string")
        this.checkTagArry = this.tableList[index].tag;
      else this.checkTagArry = [];
    }
  },
  components: {
    pagination,
    elementHint,
    tableHeader,
    skuList,
    ShopType,
    timeDataSelector,
    couponsStyle,
    batchMarkingChild
  },
  filters: {
    newArrayq: function (value) {
      if (value) {
        var ss = [];
        if (value) {
          var s = value;
          ss = s.split(",");
        }
        return ss;
      }
    },
    bjBigSmall: aes.bjBigSmall,
    objToAr: aes.objToArr
  }
};
</script>

<style scoped lang="scss">
$colorBlur: #409eff;
@import "src/style/common";

.mainChild {
  .ellipsis {
    width: 100%;
  }

  .el-button--primary.is-plain {
    margin-top: 5px;
  }

  .downContainer {
    margin-top: 5px;
  }

  .zhiwen_status {
    width: 20px;
    height: 20px;
  }

  .skuList {
    color: $colorBlur;
    cursor: pointer;
  }

  .two_ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 2em;
    max-height: 50px;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    font-weight: 600;
  }

  .edit_icon_bj {
    width: 14px;
    height: 14px;
  }

  .el-dialog__wrapper {
    display: flex;
    align-items: center;
  }

  .el-dialog {
    margin-top: 0 !important;

    .el-input__inner {
      width: 100%;
    }
  }

  .el-dialog__body {
    display: flex;

    span {
      // width: 50px;
      display: inline-block;
    }

    .el-cascader--small {
      width: calc(100% - 60px);
    }
  }

  .content-warpper {
    min-height: 766px;
  }

  box-sizing: border-box;

  .headerBrand {
    position: relative;
  }

  .plaChange {
    background: #fff;
    position: absolute;
    font-size: 12px;
    color: #666666;
    right: -15px;
    top: -84px;
    width: 236px;
    height: 80px;
    border-radius: 6px;
    box-shadow: 0 1px 7px rgba(102, 102, 102, 0.2);
    text-align: left;
    line-height: 20px;
    padding: 7px 10px;

    .alreadyUpdate {
      color: #d4282d;
    }
  }

  .dangerTag {
    color: #e90e24;
    font-size: 12px;
    border: 1px solid #e90e24;
    border-radius: 2px;
    padding: 0 3px;
    font-weight: bold;
    margin-right: 5px;
    margin-bottom: 5px;
    height: 17px;
    line-height: 17px;
  }

  .title {
    text-align: center;

    span {
      padding-left: 33px;
      cursor: pointer;
    }

    .span:hover,
    .active {
      color: #108cee;
    }
  }

  .searchContainer {
    .searchContainerMainInfo {
      margin: auto;
      position: relative;
    }

    .searchContainerMain {
      min-width: 500px;
      max-width: 612px;
      margin: auto;
      position: relative;

      .searchCondition {
        position: absolute;
        left: 0;
        bottom: -60px;
        background: #fff;
        width: 500px;
        min-height: 59px;
        display: flex;
        justify-content: flex-start;

        .searchConditionMain {
          width: 358px;
          box-shadow: 0 4px 5px #efefef;
          display: flex;
          justify-content: flex-start;
          padding: 3px;
          box-sizing: border-box;
        }

        .checkTag {
          margin-left: 10px;
          display: flex;
        }
      }
    }
  }

  .downBtn {
    display: flex;
    justify-content: flex-start;
  }

  .discount {
    text-align: center;
    font-size: 12px;
    color: white;
    margin-bottom: 7px;
    line-height: 20px;
    float: left;
    clear: both;
  }

  .shopInfo {
    img {
      width: 40px;
      height: 35px;
    }
  }

  .shopMain {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    // margin-bottom: 5px;
    .content {
      width: calc(100% - 58px);
    }

    img {
      width: 84px;
      height: 84px;
      margin-right: 12px;
      display: block;
    }
  }

  .tall_icon {
    display: flex;
    align-items: center;

    img {
      margin-right: 9px;
    }

    .green {
      background: #52c41a;
    }
  }

  .serachBtn {
    display: inline-block;
    color: #fff;
    width: 66px;
    height: 37px;
    line-height: 37px;
    border-radius: 4px;
    font-size: 4px;
    cursor: pointer;
  }

  .redstyle {
    margin-top: 2px;
    margin-right: 7px;
    float: left;
    background-color: red;
    height: 20px;
    color: white;
    text-align: center;
    line-height: 20px;
    border-radius: 20px;
  }

  .productnameEdit {
    display: flex;
    justify-content: flex-start;

    .el-icon-arrow-down {
      margin-top: 5px;
      margin-left: 5px;
    }
  }
}
</style>
<style lang="scss">
$blue: #409eff;
$ts: #faad14;

.test_low_price {
  background: $ts !important;

  .popper__arrow:after {
    border-bottom-color: $ts !important;
  }

  .popper__arrow {
    border-bottom-color: $ts !important;
  }
}

#setTags {
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }

  .el-button--primary {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }

  .el-button--primary:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }

  .el-checkbox-button:first-child .el-checkbox-button__inner {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    -webkit-box-shadow: none !important;
    margin: 5px;
    box-shadow: none !important;
  }

  .el-checkbox-button--mini .el-checkbox-button__inner {
    padding: 7px 15px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    margin: 5px;
  }

  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    color: #bda571;
    background-color: #f8f6f1;
    border-color: #bda571;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .el-checkbox-button__inner:hover {
    color: #bda571;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #bda571;
    background: #bda571;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #666;
  }

  .el-radio__inner:hover {
    border-color: #bda571;
  }

  #setTagsAdd {
    .el-button {
      border: 1px dashed #DCDFE6 !important;
    }
  }

  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }

  .el-button--TheCustom:hover {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
}

#mainChild {
  .el-table-column--selection .cell {
    text-align: center;
  }

  .lastTime {
    height: 100%;
  }

  .el-link--inner {
    display: block;
    width: 100%;
  }

  .el-icon-warning {
    color: $ts;
  }

  .test {
    background: #1ab394 !important;
  }

  .align_left {
    text-align: left;
  }

  .cell {
    text-align: left;
  }

  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }

  .ifproduct {
    .el-dialog__body {
      display: flex;
    }

    .el-input__inner {
      height: 32px !important;
    }

    .el-input__icon {
      line-height: 20px;
    }

    .productSelect1 {
      width: 32%;
    }

    .productSelect2 {
      width: 50%;
    }
  }

  .el-radio-button__inner {
    padding: 3px 5px;
    font-size: 12px;
  }

  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #fff;
    color: $blue;
  }

  .el-radio-button {
    margin-right: 5px;
  }

  .el-radio-group {
    display: flex;
    justify-content: flex-start;
  }

  .checkTag {
    .el-tag {
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      color: $blue;
      background: #fff;
      border-color: #409eff;
      margin-right: 5px;
    }

    .el-icon-error {
      color: #dbdbdb;
      margin-top: 2px;

      .cell {
        padding-left: 0;
      }
    }
  }

  .el-table-column--selection .cell {
    padding: 0;
  }

  .el-table th>.cell {
    font-size: 14px;
    color: #333333;
  }

  .circle {
    width: 5px;
    height: 5px;
    background-color: red;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    margin-top: 13px;
    margin-right: 5px;
  }

  .change {
    background: #faad14;
    color: #fff;
    width: 20px;
    height: 18px;
    line-height: 13px;
    text-align: center;
    padding: 2px 3px;
  }

  .carlss {
    width: 163px;
    height: 185px;
    background: white;
    position: absolute;
    top: 142px;
    z-index: 9999;
    left: 96px;
    color: white;
  }

  .el-table::before,
  .el-table__fixed-right::before,
  .el-table__fixed::before {
    height: 0 !important;
  }

  .el-table th {
    background: #f3f7ff;
  }

  .searchCheck .el-popper[x-placement^="bottom"] {
    height: 60px;
  }

  .el-popper[x-placement^="bottom"] .popper__arrow {
    display: none;
  }

  .el-scrollbar {
    background: #fff;
  }

  .setTag {
    .el-checkbox.is-bordered+.el-checkbox.is-bordered {
      margin-left: 0;
    }
  }
}
</style>
